import { jsx } from "react/jsx-runtime";
import * as React from "react";
import React__default, { createContext, Component, createElement as createElement$1, isValidElement, useId } from "react";
import { FeatureHubContextProvider, FeatureAppContainer, FeatureAppLoader } from "@feature-hub/react";
import require$$0 from "react-dom";
const FeatureAppEnvContext = React.createContext(void 0), FeatureAppEnvProvider = ({
  children: s,
  env: e
}) => /* @__PURE__ */ jsx(FeatureAppEnvContext.Provider, { value: e, children: s });
function useFeatureAppEnv() {
  const s = React.useContext(FeatureAppEnvContext);
  if (!s)
    throw new Error("FeatureAppEnvContext provider is missing.");
  return s;
}
function usePriceType() {
  var u, l, f;
  const {
    featureServices: {
      "login-service": s,
      "adb-context-service": e,
      "price-preferences-provider": r
    }
  } = useFeatureAppEnv(), n = s.loginState.status === "logged-in", o = !!(n && ((u = e.adbContext) != null && u.hasCustomer) && ((l = e.adbContext) != null && l.customerType)) ? (f = e.adbContext) == null ? void 0 : f.customerType : n ? s.loginState.customerType : r.getPriceType(), [c, d] = React.useState(o);
  return React.useEffect(() => {
    if (!n) {
      const h = r.subscribe(
        () => d(r.getPriceType())
      );
      return () => {
        h();
      };
    }
    return () => {
    };
  }, [r, s, n]), [c, r.setPriceType];
}
var util;
(function(s) {
  s.assertEqual = (a) => a;
  function e(a) {
  }
  s.assertIs = e;
  function r(a) {
    throw new Error();
  }
  s.assertNever = r, s.arrayToEnum = (a) => {
    const o = {};
    for (const c of a)
      o[c] = c;
    return o;
  }, s.getValidEnumValues = (a) => {
    const o = s.objectKeys(a).filter((d) => typeof a[a[d]] != "number"), c = {};
    for (const d of o)
      c[d] = a[d];
    return s.objectValues(c);
  }, s.objectValues = (a) => s.objectKeys(a).map(function(o) {
    return a[o];
  }), s.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const o = [];
    for (const c in a)
      Object.prototype.hasOwnProperty.call(a, c) && o.push(c);
    return o;
  }, s.find = (a, o) => {
    for (const c of a)
      if (o(c))
        return c;
  }, s.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, o = " | ") {
    return a.map((c) => typeof c == "string" ? `'${c}'` : c).join(o);
  }
  s.joinValues = n, s.jsonStringifyReplacer = (a, o) => typeof o == "bigint" ? o.toString() : o;
})(util || (util = {}));
var objectUtil;
(function(s) {
  s.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), getParsedType = (s) => {
  switch (typeof s) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(s) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      return Array.isArray(s) ? ZodParsedType.array : s === null ? ZodParsedType.null : s.then && typeof s.then == "function" && s.catch && typeof s.catch == "function" ? ZodParsedType.promise : typeof Map < "u" && s instanceof Map ? ZodParsedType.map : typeof Set < "u" && s instanceof Set ? ZodParsedType.set : typeof Date < "u" && s instanceof Date ? ZodParsedType.date : ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
}, ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), quotelessJson = (s) => JSON.stringify(s, null, 2).replace(/"([^"]+)":/g, "$1:");
class ZodError extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(o) {
      return o.message;
    }, n = { _errors: [] }, a = (o) => {
      for (const c of o.issues)
        if (c.code === "invalid_union")
          c.unionErrors.map(a);
        else if (c.code === "invalid_return_type")
          a(c.returnTypeError);
        else if (c.code === "invalid_arguments")
          a(c.argumentsError);
        else if (c.path.length === 0)
          n._errors.push(r(c));
        else {
          let d = n, u = 0;
          for (; u < c.path.length; ) {
            const l = c.path[u];
            u === c.path.length - 1 ? (d[l] = d[l] || { _errors: [] }, d[l]._errors.push(r(c))) : d[l] = d[l] || { _errors: [] }, d = d[l], u++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof ZodError))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (s) => new ZodError(s);
const errorMap = (s, e) => {
  let r;
  switch (s.code) {
    case ZodIssueCode.invalid_type:
      s.received === ZodParsedType.undefined ? r = "Required" : r = `Expected ${s.expected}, received ${s.received}`;
      break;
    case ZodIssueCode.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(s.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${util.joinValues(s.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      r = "Invalid input";
      break;
    case ZodIssueCode.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${util.joinValues(s.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      r = `Invalid enum value. Expected ${util.joinValues(s.options)}, received '${s.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case ZodIssueCode.invalid_return_type:
      r = "Invalid function return type";
      break;
    case ZodIssueCode.invalid_date:
      r = "Invalid date";
      break;
    case ZodIssueCode.invalid_string:
      typeof s.validation == "object" ? "includes" in s.validation ? (r = `Invalid input: must include "${s.validation.includes}"`, typeof s.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${s.validation.position}`)) : "startsWith" in s.validation ? r = `Invalid input: must start with "${s.validation.startsWith}"` : "endsWith" in s.validation ? r = `Invalid input: must end with "${s.validation.endsWith}"` : util.assertNever(s.validation) : s.validation !== "regex" ? r = `Invalid ${s.validation}` : r = "Invalid";
      break;
    case ZodIssueCode.too_small:
      s.type === "array" ? r = `Array must contain ${s.exact ? "exactly" : s.inclusive ? "at least" : "more than"} ${s.minimum} element(s)` : s.type === "string" ? r = `String must contain ${s.exact ? "exactly" : s.inclusive ? "at least" : "over"} ${s.minimum} character(s)` : s.type === "number" ? r = `Number must be ${s.exact ? "exactly equal to " : s.inclusive ? "greater than or equal to " : "greater than "}${s.minimum}` : s.type === "date" ? r = `Date must be ${s.exact ? "exactly equal to " : s.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(s.minimum))}` : r = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      s.type === "array" ? r = `Array must contain ${s.exact ? "exactly" : s.inclusive ? "at most" : "less than"} ${s.maximum} element(s)` : s.type === "string" ? r = `String must contain ${s.exact ? "exactly" : s.inclusive ? "at most" : "under"} ${s.maximum} character(s)` : s.type === "number" ? r = `Number must be ${s.exact ? "exactly" : s.inclusive ? "less than or equal to" : "less than"} ${s.maximum}` : s.type === "bigint" ? r = `BigInt must be ${s.exact ? "exactly" : s.inclusive ? "less than or equal to" : "less than"} ${s.maximum}` : s.type === "date" ? r = `Date must be ${s.exact ? "exactly" : s.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(s.maximum))}` : r = "Invalid input";
      break;
    case ZodIssueCode.custom:
      r = "Invalid input";
      break;
    case ZodIssueCode.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case ZodIssueCode.not_multiple_of:
      r = `Number must be a multiple of ${s.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, util.assertNever(s);
  }
  return { message: r };
};
let overrideErrorMap = errorMap;
function setErrorMap(s) {
  overrideErrorMap = s;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (s) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = s, o = [...r, ...a.path || []], c = {
    ...a,
    path: o
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: o,
      message: a.message
    };
  let d = "";
  const u = n.filter((l) => !!l).slice().reverse();
  for (const l of u)
    d = l(c, { data: e, defaultError: d }).message;
  return {
    ...a,
    path: o,
    message: d
  };
}, EMPTY_PATH = [];
function addIssueToContext(s, e) {
  const r = getErrorMap(), n = makeIssue({
    issueData: e,
    data: s.data,
    path: s.path,
    errorMaps: [
      s.common.contextualErrorMap,
      s.schemaErrorMap,
      r,
      r === errorMap ? void 0 : errorMap
      // then global default map
    ].filter((a) => !!a)
  });
  s.common.issues.push(n);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return INVALID;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const o = await a.key, c = await a.value;
      n.push({
        key: o,
        value: c
      });
    }
    return ParseStatus.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: o, value: c } = a;
      if (o.status === "aborted" || c.status === "aborted")
        return INVALID;
      o.status === "dirty" && e.dirty(), c.status === "dirty" && e.dirty(), o.value !== "__proto__" && (typeof c.value < "u" || a.alwaysSet) && (n[o.value] = c.value);
    }
    return { status: e.value, value: n };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
}), DIRTY = (s) => ({ status: "dirty", value: s }), OK = (s) => ({ status: "valid", value: s }), isAborted = (s) => s.status === "aborted", isDirty = (s) => s.status === "dirty", isValid = (s) => s.status === "valid", isAsync = (s) => typeof Promise < "u" && s instanceof Promise;
function __classPrivateFieldGet(s, e, r, n) {
  if (typeof e == "function" ? s !== e || !n : !e.has(s)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(s);
}
function __classPrivateFieldSet(s, e, r, n, a) {
  if (typeof e == "function" ? s !== e || !a : !e.has(s)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(s, r), r;
}
typeof SuppressedError == "function" && SuppressedError;
var errorUtil;
(function(s) {
  s.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, s.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const handleResult = (s, e) => {
  if (isValid(e))
    return { success: !0, data: e.value };
  if (!s.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new ZodError(s.common.issues);
      return this._error = r, this._error;
    }
  };
};
function processCreateParams(s) {
  if (!s)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = s;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (c, d) => {
    var u, l;
    const { message: f } = s;
    return c.code === "invalid_enum_value" ? { message: f ?? d.defaultError } : typeof d.data > "u" ? { message: (u = f ?? n) !== null && u !== void 0 ? u : d.defaultError } : c.code !== "invalid_type" ? { message: d.defaultError } : { message: (l = f ?? r) !== null && l !== void 0 ? l : d.defaultError };
  }, description: a };
}
class ZodType {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return getParsedType(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: getParsedType(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: getParsedType(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (isAsync(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: getParsedType(e)
    }, o = this._parseSync({ data: e, path: a.path, parent: a });
    return handleResult(a, o);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: getParsedType(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), o = await (isAsync(a) ? a : Promise.resolve(a));
    return handleResult(n, o);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, o) => {
      const c = e(a), d = () => o.addIssue({
        code: ZodIssueCode.custom,
        ...n(a)
      });
      return typeof Promise < "u" && c instanceof Promise ? c.then((u) => u ? !0 : (d(), !1)) : c ? !0 : (d(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(e) {
    return ZodUnion.create([this, e], this._def);
  }
  and(e) {
    return ZodIntersection.create(this, e, this._def);
  }
  transform(e) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: r,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: r,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return ZodPipeline.create(this, e);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i, cuid2Regex = /^[0-9a-z]+$/, ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/, uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, nanoidRegex = /^[a-z0-9_-]{21}$/i, durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let emojiRegex;
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, dateRegexSource = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(s) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return s.precision ? e = `${e}\\.\\d{${s.precision}}` : s.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function timeRegex(s) {
  return new RegExp(`^${timeRegexSource(s)}$`);
}
function datetimeRegex(s) {
  let e = `${dateRegexSource}T${timeRegexSource(s)}`;
  const r = [];
  return r.push(s.local ? "Z?" : "Z"), s.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function isValidIP(s, e) {
  return !!((e === "v4" || !e) && ipv4Regex.test(s) || (e === "v6" || !e) && ipv6Regex.test(s));
}
class ZodString extends ZodType {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== ZodParsedType.string) {
      const o = this._getOrReturnCtx(e);
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: o.parsedType
      }), INVALID;
    }
    const n = new ParseStatus();
    let a;
    for (const o of this._def.checks)
      if (o.kind === "min")
        e.data.length < o.value && (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          code: ZodIssueCode.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), n.dirty());
      else if (o.kind === "max")
        e.data.length > o.value && (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          code: ZodIssueCode.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), n.dirty());
      else if (o.kind === "length") {
        const c = e.data.length > o.value, d = e.data.length < o.value;
        (c || d) && (a = this._getOrReturnCtx(e, a), c ? addIssueToContext(a, {
          code: ZodIssueCode.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : d && addIssueToContext(a, {
          code: ZodIssueCode.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), n.dirty());
      } else if (o.kind === "email")
        emailRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          validation: "email",
          code: ZodIssueCode.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "emoji")
        emojiRegex || (emojiRegex = new RegExp(_emojiRegex, "u")), emojiRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          validation: "emoji",
          code: ZodIssueCode.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "uuid")
        uuidRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          validation: "uuid",
          code: ZodIssueCode.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "nanoid")
        nanoidRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          validation: "nanoid",
          code: ZodIssueCode.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "cuid")
        cuidRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          validation: "cuid",
          code: ZodIssueCode.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "cuid2")
        cuid2Regex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          validation: "cuid2",
          code: ZodIssueCode.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "ulid")
        ulidRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
          validation: "ulid",
          code: ZodIssueCode.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: o.message
          }), n.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        validation: "regex",
        code: ZodIssueCode.invalid_string,
        message: o.message
      }), n.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), n.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), n.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), n.dirty()) : o.kind === "datetime" ? datetimeRegex(o).test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: "datetime",
        message: o.message
      }), n.dirty()) : o.kind === "date" ? dateRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: "date",
        message: o.message
      }), n.dirty()) : o.kind === "time" ? timeRegex(o).test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.invalid_string,
        validation: "time",
        message: o.message
      }), n.dirty()) : o.kind === "duration" ? durationRegex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        validation: "duration",
        code: ZodIssueCode.invalid_string,
        message: o.message
      }), n.dirty()) : o.kind === "ip" ? isValidIP(e.data, o.version) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        validation: "ip",
        code: ZodIssueCode.invalid_string,
        message: o.message
      }), n.dirty()) : o.kind === "base64" ? base64Regex.test(e.data) || (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        validation: "base64",
        code: ZodIssueCode.invalid_string,
        message: o.message
      }), n.dirty()) : util.assertNever(o);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(n)
    });
  }
  _addCheck(e) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...errorUtil.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...errorUtil.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...errorUtil.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...errorUtil.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...errorUtil.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...errorUtil.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...errorUtil.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...errorUtil.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...errorUtil.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, errorUtil.errToObj(e));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
ZodString.create = (s) => {
  var e;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (e = s == null ? void 0 : s.coerce) !== null && e !== void 0 ? e : !1,
    ...processCreateParams(s)
  });
};
function floatSafeRemainder(s, e) {
  const r = (s.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, o = parseInt(s.toFixed(a).replace(".", "")), c = parseInt(e.toFixed(a).replace(".", ""));
  return o % c / Math.pow(10, a);
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== ZodParsedType.number) {
      const o = this._getOrReturnCtx(e);
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: o.parsedType
      }), INVALID;
    }
    let n;
    const a = new ParseStatus();
    for (const o of this._def.checks)
      o.kind === "int" ? util.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), a.dirty()) : o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), a.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), a.dirty()) : o.kind === "multipleOf" ? floatSafeRemainder(e.data, o.value) !== 0 && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), a.dirty()) : o.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.not_finite,
        message: o.message
      }), a.dirty()) : util.assertNever(o);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, errorUtil.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, errorUtil.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, errorUtil.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, errorUtil.toString(r));
  }
  setLimit(e, r, n, a) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: errorUtil.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: errorUtil.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && util.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
ZodNumber.create = (s) => new ZodNumber({
  checks: [],
  typeName: ZodFirstPartyTypeKind.ZodNumber,
  coerce: (s == null ? void 0 : s.coerce) || !1,
  ...processCreateParams(s)
});
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== ZodParsedType.bigint) {
      const o = this._getOrReturnCtx(e);
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: o.parsedType
      }), INVALID;
    }
    let n;
    const a = new ParseStatus();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), a.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), a.dirty()) : o.kind === "multipleOf" ? e.data % o.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), addIssueToContext(n, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), a.dirty()) : util.assertNever(o);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, errorUtil.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, errorUtil.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, errorUtil.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, errorUtil.toString(r));
  }
  setLimit(e, r, n, a) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: errorUtil.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: errorUtil.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
ZodBigInt.create = (s) => {
  var e;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (e = s == null ? void 0 : s.coerce) !== null && e !== void 0 ? e : !1,
    ...processCreateParams(s)
  });
};
class ZodBoolean extends ZodType {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== ZodParsedType.boolean) {
      const n = this._getOrReturnCtx(e);
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: n.parsedType
      }), INVALID;
    }
    return OK(e.data);
  }
}
ZodBoolean.create = (s) => new ZodBoolean({
  typeName: ZodFirstPartyTypeKind.ZodBoolean,
  coerce: (s == null ? void 0 : s.coerce) || !1,
  ...processCreateParams(s)
});
class ZodDate extends ZodType {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== ZodParsedType.date) {
      const o = this._getOrReturnCtx(e);
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: o.parsedType
      }), INVALID;
    }
    if (isNaN(e.data.getTime())) {
      const o = this._getOrReturnCtx(e);
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_date
      }), INVALID;
    }
    const n = new ParseStatus();
    let a;
    for (const o of this._def.checks)
      o.kind === "min" ? e.data.getTime() < o.value && (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), n.dirty()) : o.kind === "max" ? e.data.getTime() > o.value && (a = this._getOrReturnCtx(e, a), addIssueToContext(a, {
        code: ZodIssueCode.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), n.dirty()) : util.assertNever(o);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: errorUtil.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: errorUtil.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
ZodDate.create = (s) => new ZodDate({
  checks: [],
  coerce: (s == null ? void 0 : s.coerce) || !1,
  typeName: ZodFirstPartyTypeKind.ZodDate,
  ...processCreateParams(s)
});
class ZodSymbol extends ZodType {
  _parse(e) {
    if (this._getType(e) !== ZodParsedType.symbol) {
      const n = this._getOrReturnCtx(e);
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: n.parsedType
      }), INVALID;
    }
    return OK(e.data);
  }
}
ZodSymbol.create = (s) => new ZodSymbol({
  typeName: ZodFirstPartyTypeKind.ZodSymbol,
  ...processCreateParams(s)
});
class ZodUndefined extends ZodType {
  _parse(e) {
    if (this._getType(e) !== ZodParsedType.undefined) {
      const n = this._getOrReturnCtx(e);
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: n.parsedType
      }), INVALID;
    }
    return OK(e.data);
  }
}
ZodUndefined.create = (s) => new ZodUndefined({
  typeName: ZodFirstPartyTypeKind.ZodUndefined,
  ...processCreateParams(s)
});
class ZodNull extends ZodType {
  _parse(e) {
    if (this._getType(e) !== ZodParsedType.null) {
      const n = this._getOrReturnCtx(e);
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: n.parsedType
      }), INVALID;
    }
    return OK(e.data);
  }
}
ZodNull.create = (s) => new ZodNull({
  typeName: ZodFirstPartyTypeKind.ZodNull,
  ...processCreateParams(s)
});
class ZodAny extends ZodType {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return OK(e.data);
  }
}
ZodAny.create = (s) => new ZodAny({
  typeName: ZodFirstPartyTypeKind.ZodAny,
  ...processCreateParams(s)
});
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return OK(e.data);
  }
}
ZodUnknown.create = (s) => new ZodUnknown({
  typeName: ZodFirstPartyTypeKind.ZodUnknown,
  ...processCreateParams(s)
});
class ZodNever extends ZodType {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return addIssueToContext(r, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: r.parsedType
    }), INVALID;
  }
}
ZodNever.create = (s) => new ZodNever({
  typeName: ZodFirstPartyTypeKind.ZodNever,
  ...processCreateParams(s)
});
class ZodVoid extends ZodType {
  _parse(e) {
    if (this._getType(e) !== ZodParsedType.undefined) {
      const n = this._getOrReturnCtx(e);
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: n.parsedType
      }), INVALID;
    }
    return OK(e.data);
  }
}
ZodVoid.create = (s) => new ZodVoid({
  typeName: ZodFirstPartyTypeKind.ZodVoid,
  ...processCreateParams(s)
});
class ZodArray extends ZodType {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== ZodParsedType.array)
      return addIssueToContext(r, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: r.parsedType
      }), INVALID;
    if (a.exactLength !== null) {
      const c = r.data.length > a.exactLength.value, d = r.data.length < a.exactLength.value;
      (c || d) && (addIssueToContext(r, {
        code: c ? ZodIssueCode.too_big : ZodIssueCode.too_small,
        minimum: d ? a.exactLength.value : void 0,
        maximum: c ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (addIssueToContext(r, {
      code: ZodIssueCode.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (addIssueToContext(r, {
      code: ZodIssueCode.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((c, d) => a.type._parseAsync(new ParseInputLazyPath(r, c, r.path, d)))).then((c) => ParseStatus.mergeArray(n, c));
    const o = [...r.data].map((c, d) => a.type._parseSync(new ParseInputLazyPath(r, c, r.path, d)));
    return ParseStatus.mergeArray(n, o);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new ZodArray({
      ...this._def,
      minLength: { value: e, message: errorUtil.toString(r) }
    });
  }
  max(e, r) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: e, message: errorUtil.toString(r) }
    });
  }
  length(e, r) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: e, message: errorUtil.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ZodArray.create = (s, e) => new ZodArray({
  type: s,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ZodFirstPartyTypeKind.ZodArray,
  ...processCreateParams(e)
});
function deepPartialify(s) {
  if (s instanceof ZodObject) {
    const e = {};
    for (const r in s.shape) {
      const n = s.shape[r];
      e[r] = ZodOptional.create(deepPartialify(n));
    }
    return new ZodObject({
      ...s._def,
      shape: () => e
    });
  } else return s instanceof ZodArray ? new ZodArray({
    ...s._def,
    type: deepPartialify(s.element)
  }) : s instanceof ZodOptional ? ZodOptional.create(deepPartialify(s.unwrap())) : s instanceof ZodNullable ? ZodNullable.create(deepPartialify(s.unwrap())) : s instanceof ZodTuple ? ZodTuple.create(s.items.map((e) => deepPartialify(e))) : s;
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = util.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== ZodParsedType.object) {
      const l = this._getOrReturnCtx(e);
      return addIssueToContext(l, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: l.parsedType
      }), INVALID;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: o, keys: c } = this._getCached(), d = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip"))
      for (const l in a.data)
        c.includes(l) || d.push(l);
    const u = [];
    for (const l of c) {
      const f = o[l], h = a.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: f._parse(new ParseInputLazyPath(a, h, a.path, l)),
        alwaysSet: l in a.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const f of d)
          u.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: a.data[f] }
          });
      else if (l === "strict")
        d.length > 0 && (addIssueToContext(a, {
          code: ZodIssueCode.unrecognized_keys,
          keys: d
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const f of d) {
        const h = a.data[f];
        u.push({
          key: { status: "valid", value: f },
          value: l._parse(
            new ParseInputLazyPath(a, h, a.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const f of u) {
        const h = await f.key, v = await f.value;
        l.push({
          key: h,
          value: v,
          alwaysSet: f.alwaysSet
        });
      }
      return l;
    }).then((l) => ParseStatus.mergeObjectSync(n, l)) : ParseStatus.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return errorUtil.errToObj, new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, o, c, d;
          const u = (c = (o = (a = this._def).errorMap) === null || o === void 0 ? void 0 : o.call(a, r, n).message) !== null && c !== void 0 ? c : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (d = errorUtil.errToObj(e).message) !== null && d !== void 0 ? d : u
          } : {
            message: u
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new ZodObject({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new ZodObject({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return util.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new ZodObject({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return util.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new ZodObject({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(e) {
    const r = {};
    return util.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new ZodObject({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return util.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let o = this.shape[n];
        for (; o instanceof ZodOptional; )
          o = o._def.innerType;
        r[n] = o;
      }
    }), new ZodObject({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
}
ZodObject.create = (s, e) => new ZodObject({
  shape: () => s,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(e)
});
ZodObject.strictCreate = (s, e) => new ZodObject({
  shape: () => s,
  unknownKeys: "strict",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(e)
});
ZodObject.lazycreate = (s, e) => new ZodObject({
  shape: s,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(e)
});
class ZodUnion extends ZodType {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(o) {
      for (const d of o)
        if (d.result.status === "valid")
          return d.result;
      for (const d of o)
        if (d.result.status === "dirty")
          return r.common.issues.push(...d.ctx.common.issues), d.result;
      const c = o.map((d) => new ZodError(d.ctx.common.issues));
      return addIssueToContext(r, {
        code: ZodIssueCode.invalid_union,
        unionErrors: c
      }), INVALID;
    }
    if (r.common.async)
      return Promise.all(n.map(async (o) => {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: r.data,
            path: r.path,
            parent: c
          }),
          ctx: c
        };
      })).then(a);
    {
      let o;
      const c = [];
      for (const u of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, f = u._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !o && (o = { result: f, ctx: l }), l.common.issues.length && c.push(l.common.issues);
      }
      if (o)
        return r.common.issues.push(...o.ctx.common.issues), o.result;
      const d = c.map((u) => new ZodError(u));
      return addIssueToContext(r, {
        code: ZodIssueCode.invalid_union,
        unionErrors: d
      }), INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (s, e) => new ZodUnion({
  options: s,
  typeName: ZodFirstPartyTypeKind.ZodUnion,
  ...processCreateParams(e)
});
const getDiscriminator = (s) => s instanceof ZodLazy ? getDiscriminator(s.schema) : s instanceof ZodEffects ? getDiscriminator(s.innerType()) : s instanceof ZodLiteral ? [s.value] : s instanceof ZodEnum ? s.options : s instanceof ZodNativeEnum ? util.objectValues(s.enum) : s instanceof ZodDefault ? getDiscriminator(s._def.innerType) : s instanceof ZodUndefined ? [void 0] : s instanceof ZodNull ? [null] : s instanceof ZodOptional ? [void 0, ...getDiscriminator(s.unwrap())] : s instanceof ZodNullable ? [null, ...getDiscriminator(s.unwrap())] : s instanceof ZodBranded || s instanceof ZodReadonly ? getDiscriminator(s.unwrap()) : s instanceof ZodCatch ? getDiscriminator(s._def.innerType) : [];
class ZodDiscriminatedUnion extends ZodType {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== ZodParsedType.object)
      return addIssueToContext(r, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: r.parsedType
      }), INVALID;
    const n = this.discriminator, a = r.data[n], o = this.optionsMap.get(a);
    return o ? r.common.async ? o._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : o._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (addIssueToContext(r, {
      code: ZodIssueCode.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), INVALID);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const o of r) {
      const c = getDiscriminator(o.shape[e]);
      if (!c.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const d of c) {
        if (a.has(d))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(d)}`);
        a.set(d, o);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...processCreateParams(n)
    });
  }
}
function mergeValues(s, e) {
  const r = getParsedType(s), n = getParsedType(e);
  if (s === e)
    return { valid: !0, data: s };
  if (r === ZodParsedType.object && n === ZodParsedType.object) {
    const a = util.objectKeys(e), o = util.objectKeys(s).filter((d) => a.indexOf(d) !== -1), c = { ...s, ...e };
    for (const d of o) {
      const u = mergeValues(s[d], e[d]);
      if (!u.valid)
        return { valid: !1 };
      c[d] = u.data;
    }
    return { valid: !0, data: c };
  } else if (r === ZodParsedType.array && n === ZodParsedType.array) {
    if (s.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let o = 0; o < s.length; o++) {
      const c = s[o], d = e[o], u = mergeValues(c, d);
      if (!u.valid)
        return { valid: !1 };
      a.push(u.data);
    }
    return { valid: !0, data: a };
  } else return r === ZodParsedType.date && n === ZodParsedType.date && +s == +e ? { valid: !0, data: s } : { valid: !1 };
}
class ZodIntersection extends ZodType {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (o, c) => {
      if (isAborted(o) || isAborted(c))
        return INVALID;
      const d = mergeValues(o.value, c.value);
      return d.valid ? ((isDirty(o) || isDirty(c)) && r.dirty(), { status: r.value, value: d.data }) : (addIssueToContext(n, {
        code: ZodIssueCode.invalid_intersection_types
      }), INVALID);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([o, c]) => a(o, c)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
ZodIntersection.create = (s, e, r) => new ZodIntersection({
  left: s,
  right: e,
  typeName: ZodFirstPartyTypeKind.ZodIntersection,
  ...processCreateParams(r)
});
class ZodTuple extends ZodType {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ZodParsedType.array)
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: n.parsedType
      }), INVALID;
    if (n.data.length < this._def.items.length)
      return addIssueToContext(n, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), INVALID;
    !this._def.rest && n.data.length > this._def.items.length && (addIssueToContext(n, {
      code: ZodIssueCode.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const o = [...n.data].map((c, d) => {
      const u = this._def.items[d] || this._def.rest;
      return u ? u._parse(new ParseInputLazyPath(n, c, n.path, d)) : null;
    }).filter((c) => !!c);
    return n.common.async ? Promise.all(o).then((c) => ParseStatus.mergeArray(r, c)) : ParseStatus.mergeArray(r, o);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new ZodTuple({
      ...this._def,
      rest: e
    });
  }
}
ZodTuple.create = (s, e) => {
  if (!Array.isArray(s))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ZodTuple({
    items: s,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(e)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ZodParsedType.object)
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: n.parsedType
      }), INVALID;
    const a = [], o = this._def.keyType, c = this._def.valueType;
    for (const d in n.data)
      a.push({
        key: o._parse(new ParseInputLazyPath(n, d, n.path, d)),
        value: c._parse(new ParseInputLazyPath(n, n.data[d], n.path, d)),
        alwaysSet: d in n.data
      });
    return n.common.async ? ParseStatus.mergeObjectAsync(r, a) : ParseStatus.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof ZodType ? new ZodRecord({
      keyType: e,
      valueType: r,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(n)
    }) : new ZodRecord({
      keyType: ZodString.create(),
      valueType: e,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(r)
    });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ZodParsedType.map)
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: n.parsedType
      }), INVALID;
    const a = this._def.keyType, o = this._def.valueType, c = [...n.data.entries()].map(([d, u], l) => ({
      key: a._parse(new ParseInputLazyPath(n, d, n.path, [l, "key"])),
      value: o._parse(new ParseInputLazyPath(n, u, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const d = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of c) {
          const l = await u.key, f = await u.value;
          if (l.status === "aborted" || f.status === "aborted")
            return INVALID;
          (l.status === "dirty" || f.status === "dirty") && r.dirty(), d.set(l.value, f.value);
        }
        return { status: r.value, value: d };
      });
    } else {
      const d = /* @__PURE__ */ new Map();
      for (const u of c) {
        const l = u.key, f = u.value;
        if (l.status === "aborted" || f.status === "aborted")
          return INVALID;
        (l.status === "dirty" || f.status === "dirty") && r.dirty(), d.set(l.value, f.value);
      }
      return { status: r.value, value: d };
    }
  }
}
ZodMap.create = (s, e, r) => new ZodMap({
  valueType: e,
  keyType: s,
  typeName: ZodFirstPartyTypeKind.ZodMap,
  ...processCreateParams(r)
});
class ZodSet extends ZodType {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ZodParsedType.set)
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: n.parsedType
      }), INVALID;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (addIssueToContext(n, {
      code: ZodIssueCode.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (addIssueToContext(n, {
      code: ZodIssueCode.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const o = this._def.valueType;
    function c(u) {
      const l = /* @__PURE__ */ new Set();
      for (const f of u) {
        if (f.status === "aborted")
          return INVALID;
        f.status === "dirty" && r.dirty(), l.add(f.value);
      }
      return { status: r.value, value: l };
    }
    const d = [...n.data.values()].map((u, l) => o._parse(new ParseInputLazyPath(n, u, n.path, l)));
    return n.common.async ? Promise.all(d).then((u) => c(u)) : c(d);
  }
  min(e, r) {
    return new ZodSet({
      ...this._def,
      minSize: { value: e, message: errorUtil.toString(r) }
    });
  }
  max(e, r) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: e, message: errorUtil.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ZodSet.create = (s, e) => new ZodSet({
  valueType: s,
  minSize: null,
  maxSize: null,
  typeName: ZodFirstPartyTypeKind.ZodSet,
  ...processCreateParams(e)
});
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== ZodParsedType.function)
      return addIssueToContext(r, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: r.parsedType
      }), INVALID;
    function n(d, u) {
      return makeIssue({
        data: d,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((l) => !!l),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: u
        }
      });
    }
    function a(d, u) {
      return makeIssue({
        data: d,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((l) => !!l),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: u
        }
      });
    }
    const o = { errorMap: r.common.contextualErrorMap }, c = r.data;
    if (this._def.returns instanceof ZodPromise) {
      const d = this;
      return OK(async function(...u) {
        const l = new ZodError([]), f = await d._def.args.parseAsync(u, o).catch((Z) => {
          throw l.addIssue(n(u, Z)), l;
        }), h = await Reflect.apply(c, this, f);
        return await d._def.returns._def.type.parseAsync(h, o).catch((Z) => {
          throw l.addIssue(a(h, Z)), l;
        });
      });
    } else {
      const d = this;
      return OK(function(...u) {
        const l = d._def.args.safeParse(u, o);
        if (!l.success)
          throw new ZodError([n(u, l.error)]);
        const f = Reflect.apply(c, this, l.data), h = d._def.returns.safeParse(f, o);
        if (!h.success)
          throw new ZodError([a(f, h.error)]);
        return h.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(e).rest(ZodUnknown.create())
    });
  }
  returns(e) {
    return new ZodFunction({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new ZodFunction({
      args: e || ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: r || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(n)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
ZodLazy.create = (s, e) => new ZodLazy({
  getter: s,
  typeName: ZodFirstPartyTypeKind.ZodLazy,
  ...processCreateParams(e)
});
class ZodLiteral extends ZodType {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return addIssueToContext(r, {
        received: r.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      }), INVALID;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (s, e) => new ZodLiteral({
  value: s,
  typeName: ZodFirstPartyTypeKind.ZodLiteral,
  ...processCreateParams(e)
});
function createZodEnum(s, e) {
  return new ZodEnum({
    values: s,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(e)
  });
}
class ZodEnum extends ZodType {
  constructor() {
    super(...arguments), _ZodEnum_cache.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return addIssueToContext(r, {
        expected: util.joinValues(n),
        received: r.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (__classPrivateFieldGet(this, _ZodEnum_cache) || __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values)), !__classPrivateFieldGet(this, _ZodEnum_cache).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return addIssueToContext(r, {
        received: r.data,
        code: ZodIssueCode.invalid_enum_value,
        options: n
      }), INVALID;
    }
    return OK(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return ZodEnum.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return ZodEnum.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
_ZodEnum_cache = /* @__PURE__ */ new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  constructor() {
    super(...arguments), _ZodNativeEnum_cache.set(this, void 0);
  }
  _parse(e) {
    const r = util.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== ZodParsedType.string && n.parsedType !== ZodParsedType.number) {
      const a = util.objectValues(r);
      return addIssueToContext(n, {
        expected: util.joinValues(a),
        received: n.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (__classPrivateFieldGet(this, _ZodNativeEnum_cache) || __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values))), !__classPrivateFieldGet(this, _ZodNativeEnum_cache).has(e.data)) {
      const a = util.objectValues(r);
      return addIssueToContext(n, {
        received: n.data,
        code: ZodIssueCode.invalid_enum_value,
        options: a
      }), INVALID;
    }
    return OK(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
_ZodNativeEnum_cache = /* @__PURE__ */ new WeakMap();
ZodNativeEnum.create = (s, e) => new ZodNativeEnum({
  values: s,
  typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
  ...processCreateParams(e)
});
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== ZodParsedType.promise && r.common.async === !1)
      return addIssueToContext(r, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: r.parsedType
      }), INVALID;
    const n = r.parsedType === ZodParsedType.promise ? r.data : Promise.resolve(r.data);
    return OK(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
ZodPromise.create = (s, e) => new ZodPromise({
  type: s,
  typeName: ZodFirstPartyTypeKind.ZodPromise,
  ...processCreateParams(e)
});
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, o = {
      addIssue: (c) => {
        addIssueToContext(n, c), c.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), a.type === "preprocess") {
      const c = a.transform(n.data, o);
      if (n.common.async)
        return Promise.resolve(c).then(async (d) => {
          if (r.value === "aborted")
            return INVALID;
          const u = await this._def.schema._parseAsync({
            data: d,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? INVALID : u.status === "dirty" || r.value === "dirty" ? DIRTY(u.value) : u;
        });
      {
        if (r.value === "aborted")
          return INVALID;
        const d = this._def.schema._parseSync({
          data: c,
          path: n.path,
          parent: n
        });
        return d.status === "aborted" ? INVALID : d.status === "dirty" || r.value === "dirty" ? DIRTY(d.value) : d;
      }
    }
    if (a.type === "refinement") {
      const c = (d) => {
        const u = a.refinement(d, o);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return d;
      };
      if (n.common.async === !1) {
        const d = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return d.status === "aborted" ? INVALID : (d.status === "dirty" && r.dirty(), c(d.value), { status: r.value, value: d.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((d) => d.status === "aborted" ? INVALID : (d.status === "dirty" && r.dirty(), c(d.value).then(() => ({ status: r.value, value: d.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const c = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!isValid(c))
          return c;
        const d = a.transform(c.value, o);
        if (d instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: d };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((c) => isValid(c) ? Promise.resolve(a.transform(c.value, o)).then((d) => ({ status: r.value, value: d })) : c);
    util.assertNever(a);
  }
}
ZodEffects.create = (s, e, r) => new ZodEffects({
  schema: s,
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  effect: e,
  ...processCreateParams(r)
});
ZodEffects.createWithPreprocess = (s, e, r) => new ZodEffects({
  schema: e,
  effect: { type: "preprocess", transform: s },
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  ...processCreateParams(r)
});
class ZodOptional extends ZodType {
  _parse(e) {
    return this._getType(e) === ZodParsedType.undefined ? OK(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (s, e) => new ZodOptional({
  innerType: s,
  typeName: ZodFirstPartyTypeKind.ZodOptional,
  ...processCreateParams(e)
});
class ZodNullable extends ZodType {
  _parse(e) {
    return this._getType(e) === ZodParsedType.null ? OK(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (s, e) => new ZodNullable({
  innerType: s,
  typeName: ZodFirstPartyTypeKind.ZodNullable,
  ...processCreateParams(e)
});
class ZodDefault extends ZodType {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === ZodParsedType.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (s, e) => new ZodDefault({
  innerType: s,
  typeName: ZodFirstPartyTypeKind.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...processCreateParams(e)
});
class ZodCatch extends ZodType {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return isAsync(a) ? a.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new ZodError(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ZodError(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (s, e) => new ZodCatch({
  innerType: s,
  typeName: ZodFirstPartyTypeKind.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...processCreateParams(e)
});
class ZodNaN extends ZodType {
  _parse(e) {
    if (this._getType(e) !== ZodParsedType.nan) {
      const n = this._getOrReturnCtx(e);
      return addIssueToContext(n, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: n.parsedType
      }), INVALID;
    }
    return { status: "valid", value: e.data };
  }
}
ZodNaN.create = (s) => new ZodNaN({
  typeName: ZodFirstPartyTypeKind.ZodNaN,
  ...processCreateParams(s)
});
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? INVALID : o.status === "dirty" ? (r.dirty(), DIRTY(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? INVALID : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new ZodPipeline({
      in: e,
      out: r,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (isValid(a) && (a.value = Object.freeze(a.value)), a);
    return isAsync(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodReadonly.create = (s, e) => new ZodReadonly({
  innerType: s,
  typeName: ZodFirstPartyTypeKind.ZodReadonly,
  ...processCreateParams(e)
});
function custom(s, e = {}, r) {
  return s ? ZodAny.create().superRefine((n, a) => {
    var o, c;
    if (!s(n)) {
      const d = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, u = (c = (o = d.fatal) !== null && o !== void 0 ? o : r) !== null && c !== void 0 ? c : !0, l = typeof d == "string" ? { message: d } : d;
      a.addIssue({ code: "custom", ...l, fatal: u });
    }
  }) : ZodAny.create();
}
const late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(s) {
  s.ZodString = "ZodString", s.ZodNumber = "ZodNumber", s.ZodNaN = "ZodNaN", s.ZodBigInt = "ZodBigInt", s.ZodBoolean = "ZodBoolean", s.ZodDate = "ZodDate", s.ZodSymbol = "ZodSymbol", s.ZodUndefined = "ZodUndefined", s.ZodNull = "ZodNull", s.ZodAny = "ZodAny", s.ZodUnknown = "ZodUnknown", s.ZodNever = "ZodNever", s.ZodVoid = "ZodVoid", s.ZodArray = "ZodArray", s.ZodObject = "ZodObject", s.ZodUnion = "ZodUnion", s.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", s.ZodIntersection = "ZodIntersection", s.ZodTuple = "ZodTuple", s.ZodRecord = "ZodRecord", s.ZodMap = "ZodMap", s.ZodSet = "ZodSet", s.ZodFunction = "ZodFunction", s.ZodLazy = "ZodLazy", s.ZodLiteral = "ZodLiteral", s.ZodEnum = "ZodEnum", s.ZodEffects = "ZodEffects", s.ZodNativeEnum = "ZodNativeEnum", s.ZodOptional = "ZodOptional", s.ZodNullable = "ZodNullable", s.ZodDefault = "ZodDefault", s.ZodCatch = "ZodCatch", s.ZodPromise = "ZodPromise", s.ZodBranded = "ZodBranded", s.ZodPipeline = "ZodPipeline", s.ZodReadonly = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (s, e = {
  message: `Input not instance of ${s.name}`
}) => custom((r) => r instanceof s, e), stringType = ZodString.create, numberType = ZodNumber.create, nanType = ZodNaN.create, bigIntType = ZodBigInt.create, booleanType = ZodBoolean.create, dateType = ZodDate.create, symbolType = ZodSymbol.create, undefinedType = ZodUndefined.create, nullType = ZodNull.create, anyType = ZodAny.create, unknownType = ZodUnknown.create, neverType = ZodNever.create, voidType = ZodVoid.create, arrayType = ZodArray.create, objectType = ZodObject.create, strictObjectType = ZodObject.strictCreate, unionType = ZodUnion.create, discriminatedUnionType = ZodDiscriminatedUnion.create, intersectionType = ZodIntersection.create, tupleType = ZodTuple.create, recordType = ZodRecord.create, mapType = ZodMap.create, setType = ZodSet.create, functionType = ZodFunction.create, lazyType = ZodLazy.create, literalType = ZodLiteral.create, enumType = ZodEnum.create, nativeEnumType = ZodNativeEnum.create, promiseType = ZodPromise.create, effectsType = ZodEffects.create, optionalType = ZodOptional.create, nullableType = ZodNullable.create, preprocessType = ZodEffects.createWithPreprocess, pipelineType = ZodPipeline.create, ostring = () => stringType().optional(), onumber = () => numberType().optional(), oboolean = () => booleanType().optional(), coerce$1 = {
  string: (s) => ZodString.create({ ...s, coerce: !0 }),
  number: (s) => ZodNumber.create({ ...s, coerce: !0 }),
  boolean: (s) => ZodBoolean.create({
    ...s,
    coerce: !0
  }),
  bigint: (s) => ZodBigInt.create({ ...s, coerce: !0 }),
  date: (s) => ZodDate.create({ ...s, coerce: !0 })
}, NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  datetimeRegex,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce: coerce$1,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  enum: enumType,
  function: functionType,
  instanceof: instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  null: nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  undefined: undefinedType,
  union: unionType,
  unknown: unknownType,
  void: voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
}), SalesChannel = /* @__PURE__ */ ((s) => (s.STATIONARY = "ADB", s.ONLINE = "web", s.DEMO = "DEMO", s))(SalesChannel || {});
z.union([
  z.literal(
    "web"
    /* ONLINE */
  ),
  z.literal(
    "ADB"
    /* STATIONARY */
  ),
  z.literal(
    "DEMO"
    /* DEMO */
  )
]).optional().default(
  "web"
  /* ONLINE */
);
z.union([
  z.literal("bg"),
  // Bulgarian
  z.literal("cs"),
  // Czech
  z.literal("da"),
  // Danish
  z.literal("de"),
  // German
  z.literal("el"),
  // Greek
  z.literal("en"),
  // English
  z.literal("es"),
  // Spanish
  z.literal("et"),
  // Estonian
  z.literal("fi"),
  // Finnish
  z.literal("fr"),
  // French
  z.literal("hr"),
  // Croatian
  z.literal("hu"),
  // Hungarian
  z.literal("is"),
  // Icelandic
  z.literal("it"),
  // Italian
  z.literal("lt"),
  // Lithuanian
  z.literal("lv"),
  // Latvian
  z.literal("mt"),
  // Maltese
  z.literal("nl"),
  // Dutch
  z.literal("pl"),
  // Polish
  z.literal("pt"),
  // Portuguese
  z.literal("ro"),
  // Romanian
  z.literal("sk"),
  // Slovak
  z.literal("sl"),
  // Slovenian
  z.literal("sv")
  // Swedish
]);
z.union([
  z.literal("bg-BG"),
  // Bulgaria
  z.literal("cs-CZ"),
  // Czech Republic
  z.literal("da-DK"),
  // Denmark
  z.literal("de-AT"),
  // Austria
  z.literal("de-CH"),
  // Switzerland (German in Switzerland)
  z.literal("de-DE"),
  // Germany
  z.literal("de-LI"),
  // Liechtenstein
  z.literal("de-LU"),
  // Luxembourg (German in Luxembourg)
  z.literal("el-CY"),
  // Cyprus (Greek in Cyprus)
  z.literal("el-GR"),
  // Greece
  z.literal("en-GB"),
  // United Kingdom
  z.literal("en-GR"),
  // Greece
  z.literal("en-IE"),
  // Ireland
  z.literal("en-IS"),
  // Iceland (English)
  z.literal("es-ES"),
  // Spain
  z.literal("et-EE"),
  // Estonia
  z.literal("fi-FI"),
  // Finland (Finnish in Finland)
  z.literal("fr-BE"),
  // Belgium (French in Belgium)
  z.literal("fr-CH"),
  // Switzerland (French in Switzerland)
  z.literal("fr-FR"),
  // France
  z.literal("fr-LU"),
  // Luxembourg (French in Luxembourg)
  z.literal("hr-HR"),
  // Croatia
  z.literal("hu-HU"),
  // Hungary
  z.literal("is-IS"),
  // Iceland
  z.literal("it-CH"),
  // Switzerland (Italian in Switzerland)
  z.literal("it-IT"),
  // Italy
  z.literal("lt-LT"),
  // Lithuania
  z.literal("lv-LV"),
  // Latvia
  z.literal("mt-MT"),
  // Malta
  z.literal("nb-NO"),
  // Norway
  z.literal("nl-BE"),
  // Belgium (Dutch in Belgium)
  z.literal("nl-NL"),
  // Netherlands
  z.literal("no-NO"),
  // Norway
  z.literal("pl-PL"),
  // Poland
  z.literal("pt-PT"),
  // Portugal
  z.literal("ro-RO"),
  // Romania
  z.literal("sk-SK"),
  // Slovakia
  z.literal("sl-SI"),
  // Slovenia
  z.literal("sv-FI"),
  // Finland (Swedish in Finland)
  z.literal("sv-SE")
  // Sweden
]);
z.union([
  z.literal("at"),
  // Austria
  z.literal("be"),
  // Belgium
  z.literal("bg"),
  // Bulgaria
  z.literal("ch"),
  // Switzerland
  z.literal("cy"),
  // Cyprus
  z.literal("cz"),
  // Czech Republic
  z.literal("de"),
  // Germany
  z.literal("dk"),
  // Denmark
  z.literal("ee"),
  // Estonia
  z.literal("es"),
  // Spain
  z.literal("fi"),
  // Finland
  z.literal("fr"),
  // France
  z.literal("gb"),
  // UK
  z.literal("gr"),
  // Greece
  z.literal("hr"),
  // Croatia
  z.literal("hu"),
  // Hungary
  z.literal("ie"),
  // Ireland
  z.literal("is"),
  // Iceland
  z.literal("it"),
  // Italy
  z.literal("li"),
  // Liechtenstein
  z.literal("lt"),
  // Lithuania
  z.literal("lu"),
  // Luxembourg
  z.literal("lv"),
  // Latvia
  z.literal("mt"),
  // Malta
  z.literal("nl"),
  // Netherlands
  z.literal("pl"),
  // Poland
  z.literal("pt"),
  // Portugal
  z.literal("ro"),
  // Romania
  z.literal("se"),
  // Sweden
  z.literal("si"),
  // Slovenia
  z.literal("sk"),
  // Slovakia
  z.literal("sb"),
  z.literal("fm"),
  z.literal("no")
]);
const PRODUCT_TYPE = {
  ACCESSORY: "ACCESSORY",
  ADDITIONAL_COST: "ADDITIONAL_COST",
  CONNECTED_SERVICE: "CONNECTED_SERVICE",
  DIGITAL_SERVICE: "DIGITAL_SERVICE",
  DOWNPAYMENT: "DOWNPAYMENT",
  // Extended warranty product
  EXTENDED_WARRANTY: "EXTENDED_WARRANTY",
  MARKETPLACE: "MARKETPLACE",
  VEHICLE_TIRE_TAX: "VEHICLETIRETAX",
  VEHICLE: "VEHICLE",
  VOUCHER: "VOUCHER",
  // ISP (Manufacturer warranty from Smart)
  WARRANTY: "WARRANTY",
  WINTER_TIRE_TAX: "WINTERTIRETAX"
};
z.union([
  z.literal(PRODUCT_TYPE.ACCESSORY),
  z.literal(PRODUCT_TYPE.ADDITIONAL_COST),
  z.literal(PRODUCT_TYPE.CONNECTED_SERVICE),
  z.literal(PRODUCT_TYPE.DIGITAL_SERVICE),
  z.literal(PRODUCT_TYPE.DOWNPAYMENT),
  z.literal(PRODUCT_TYPE.EXTENDED_WARRANTY),
  z.literal(PRODUCT_TYPE.MARKETPLACE),
  z.literal(PRODUCT_TYPE.VEHICLE_TIRE_TAX),
  z.literal(PRODUCT_TYPE.VEHICLE),
  z.literal(PRODUCT_TYPE.VOUCHER),
  z.literal(PRODUCT_TYPE.WARRANTY),
  z.literal(PRODUCT_TYPE.WINTER_TIRE_TAX)
]);
z.union([
  z.literal("dev"),
  z.literal("sit"),
  z.literal("stage"),
  z.literal("prod")
]);
z.union([z.literal("true"), z.literal("false")]).transform((s) => s === "true");
const headerSchema = z.object({
  headerName: z.string(),
  headerValue: z.string()
});
z.union([headerSchema, z.string().refine((s) => s.includes(":"))]).transform((s, e) => {
  if (typeof s == "object")
    return s;
  {
    const [r, n] = s.split(":");
    return !r || !n ? (e.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Input was incorrect"
    }), z.NEVER) : { headerName: r, headerValue: n };
  }
}).optional();
const ONFIDO_POLLING_STATUS = {
  AWAITING_INPUT: "awaiting_input",
  DECLINED: "declined",
  NONE: "",
  PROCESSING: "processing",
  UNVERIFIED: "unverified"
}, ONFIDO_FINAL_STATUS = {
  ABANDONED: "abandoned",
  APPROVED: "approved",
  ERROR: "error",
  REVIEW: "review"
}, ONFIDO_STATUS = {
  ...ONFIDO_POLLING_STATUS,
  ...ONFIDO_FINAL_STATUS
};
z.union([
  z.literal(ONFIDO_STATUS.AWAITING_INPUT),
  z.literal(ONFIDO_STATUS.DECLINED),
  z.literal(ONFIDO_STATUS.PROCESSING),
  z.literal(ONFIDO_STATUS.UNVERIFIED)
]).optional();
z.union([
  z.literal(ONFIDO_STATUS.ABANDONED),
  z.literal(ONFIDO_STATUS.APPROVED),
  z.literal(ONFIDO_STATUS.ERROR),
  z.literal(ONFIDO_STATUS.REVIEW)
]).optional();
z.union([
  z.literal("HX11"),
  // Smart #1
  z.literal("HC11")
  // Smart #3
]);
function useSalesChannel() {
  const { featureServices: s } = useFeatureAppEnv(), { adbContext: e } = s["adb-context-service"];
  return window.sessionStorage.getItem("demoVehicle") === "true" && (e != null && e.hasCustomer) ? SalesChannel.DEMO : e != null && e.hasCustomer ? SalesChannel.STATIONARY : SalesChannel.ONLINE;
}
const createRootLocationFromUrl = (s) => {
  const { pathname: e, searchParams: r } = new URL(s, window.location.origin);
  return { pathname: e, search: r.toString() || void 0 };
};
function useSpaNavigation() {
  const { rootHistory: s } = useFeatureAppEnv().featureServices["s2:history"];
  return (r) => {
    s.push(createRootLocationFromUrl(r));
  };
}
const ErrorBoundaryContext = createContext(null), initialState = {
  didCatch: !1,
  error: null
};
class ErrorBoundary extends Component {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = initialState;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var r, n, a = arguments.length, o = new Array(a), c = 0; c < a; c++)
        o[c] = arguments[c];
      (r = (n = this.props).onReset) === null || r === void 0 || r.call(n, {
        args: o,
        reason: "imperative-api"
      }), this.setState(initialState);
    }
  }
  componentDidCatch(e, r) {
    var n, a;
    (n = (a = this.props).onError) === null || n === void 0 || n.call(a, e, r);
  }
  componentDidUpdate(e, r) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: a
    } = this.props;
    if (n && r.error !== null && hasArrayChanged(e.resetKeys, a)) {
      var o, c;
      (o = (c = this.props).onReset) === null || o === void 0 || o.call(c, {
        next: a,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(initialState);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: r,
      FallbackComponent: n,
      fallback: a
    } = this.props, {
      didCatch: o,
      error: c
    } = this.state;
    let d = e;
    if (o) {
      const u = {
        error: c,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof r == "function")
        d = r(u);
      else if (n)
        d = createElement$1(n, u);
      else if (a === null || isValidElement(a))
        d = a;
      else
        throw c;
    }
    return createElement$1(ErrorBoundaryContext.Provider, {
      value: {
        didCatch: o,
        error: c,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, d);
  }
}
function hasArrayChanged() {
  let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return s.length !== e.length || s.some((r, n) => !Object.is(r, e[n]));
}
function createPromiseWrapper() {
  let s, e, r = !1;
  return {
    promise: new Promise((a, o) => {
      s = a, e = o;
    }),
    resolve: (a) => {
      r = !0, s(a ?? void 0);
    },
    reject: (a) => {
      r = !0, e(a);
    },
    isFulfilled: () => r
  };
}
function createFeatureAppDefinition({
  App: s,
  fallback: e,
  loading: r
}) {
  return {
    dependencies: {
      featureServices: {
        "adb-context-service": "^2.0.0",
        "endpoint-directory": "^3.0.0",
        "locale-service": "^3.0.0",
        "login-service": "^3.0.0",
        "page-context-service": "^1.0.0",
        "payment-config-service": "^1.0.0",
        "price-preferences-provider": "^1.0.0",
        "pub-sub": "^1.0.0",
        "s2:history": "^3.0.0",
        "s2:logger": "^1.0.0",
        "selected-vehicle-service": "^1.0.0"
      }
    },
    create: (n) => {
      const a = createPromiseWrapper(), o = (c) => {
        if (n != null && n.done && n.done(), c) {
          a.reject(c);
          return;
        }
        a.resolve();
      };
      return {
        loadingPromise: a.promise,
        render: () => /* @__PURE__ */ jsx(React.Suspense, { fallback: r, children: /* @__PURE__ */ jsx(
          FeatureAppEnvProvider,
          {
            env: {
              ...n,
              done: o
            },
            children: /* @__PURE__ */ jsx(ErrorBoundary, { fallback: e ?? /* @__PURE__ */ jsx("div", { children: "Error" }), children: /* @__PURE__ */ jsx(s, { done: o }) })
          }
        ) })
      };
    }
  };
}
class AsyncValue {
  constructor(e, r, n) {
    this.promise = e, this.value = r, this.error = n, e.then((a) => this.value = a).catch((a) => this.error = a);
  }
}
function getDefaultExportFromCjs(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
class LRUCache {
  constructor() {
    this.max = 1e3, this.map = /* @__PURE__ */ new Map();
  }
  get(e) {
    const r = this.map.get(e);
    if (r !== void 0)
      return this.map.delete(e), this.map.set(e, r), r;
  }
  delete(e) {
    return this.map.delete(e);
  }
  set(e, r) {
    if (!this.delete(e) && r !== void 0) {
      if (this.map.size >= this.max) {
        const a = this.map.keys().next().value;
        this.delete(a);
      }
      this.map.set(e, r);
    }
    return this;
  }
}
var lrucache = LRUCache;
const looseOption = Object.freeze({ loose: !0 }), emptyOpts = Object.freeze({}), parseOptions$1 = (s) => s ? typeof s != "object" ? looseOption : s : emptyOpts;
var parseOptions_1 = parseOptions$1, re$2 = { exports: {} };
const SEMVER_SPEC_VERSION = "2.0.0", MAX_LENGTH$1 = 256, MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16, MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6, RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$1 = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...s) => console.error("SEMVER", ...s) : () => {
};
var debug_1 = debug$1;
(function(s, e) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: r,
    MAX_SAFE_BUILD_LENGTH: n,
    MAX_LENGTH: a
  } = constants, o = debug_1;
  e = s.exports = {};
  const c = e.re = [], d = e.safeRe = [], u = e.src = [], l = e.t = {};
  let f = 0;
  const h = "[a-zA-Z0-9-]", v = [
    ["\\s", 1],
    ["\\d", a],
    [h, n]
  ], Z = (w) => {
    for (const [A, L] of v)
      w = w.split(`${A}*`).join(`${A}{0,${L}}`).split(`${A}+`).join(`${A}{1,${L}}`);
    return w;
  }, y = (w, A, L) => {
    const F = Z(A), E = f++;
    o(w, E, A), l[w] = E, u[E] = A, c[E] = new RegExp(A, L ? "g" : void 0), d[E] = new RegExp(F, L ? "g" : void 0);
  };
  y("NUMERICIDENTIFIER", "0|[1-9]\\d*"), y("NUMERICIDENTIFIERLOOSE", "\\d+"), y("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${h}*`), y("MAINVERSION", `(${u[l.NUMERICIDENTIFIER]})\\.(${u[l.NUMERICIDENTIFIER]})\\.(${u[l.NUMERICIDENTIFIER]})`), y("MAINVERSIONLOOSE", `(${u[l.NUMERICIDENTIFIERLOOSE]})\\.(${u[l.NUMERICIDENTIFIERLOOSE]})\\.(${u[l.NUMERICIDENTIFIERLOOSE]})`), y("PRERELEASEIDENTIFIER", `(?:${u[l.NUMERICIDENTIFIER]}|${u[l.NONNUMERICIDENTIFIER]})`), y("PRERELEASEIDENTIFIERLOOSE", `(?:${u[l.NUMERICIDENTIFIERLOOSE]}|${u[l.NONNUMERICIDENTIFIER]})`), y("PRERELEASE", `(?:-(${u[l.PRERELEASEIDENTIFIER]}(?:\\.${u[l.PRERELEASEIDENTIFIER]})*))`), y("PRERELEASELOOSE", `(?:-?(${u[l.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${u[l.PRERELEASEIDENTIFIERLOOSE]})*))`), y("BUILDIDENTIFIER", `${h}+`), y("BUILD", `(?:\\+(${u[l.BUILDIDENTIFIER]}(?:\\.${u[l.BUILDIDENTIFIER]})*))`), y("FULLPLAIN", `v?${u[l.MAINVERSION]}${u[l.PRERELEASE]}?${u[l.BUILD]}?`), y("FULL", `^${u[l.FULLPLAIN]}$`), y("LOOSEPLAIN", `[v=\\s]*${u[l.MAINVERSIONLOOSE]}${u[l.PRERELEASELOOSE]}?${u[l.BUILD]}?`), y("LOOSE", `^${u[l.LOOSEPLAIN]}$`), y("GTLT", "((?:<|>)?=?)"), y("XRANGEIDENTIFIERLOOSE", `${u[l.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), y("XRANGEIDENTIFIER", `${u[l.NUMERICIDENTIFIER]}|x|X|\\*`), y("XRANGEPLAIN", `[v=\\s]*(${u[l.XRANGEIDENTIFIER]})(?:\\.(${u[l.XRANGEIDENTIFIER]})(?:\\.(${u[l.XRANGEIDENTIFIER]})(?:${u[l.PRERELEASE]})?${u[l.BUILD]}?)?)?`), y("XRANGEPLAINLOOSE", `[v=\\s]*(${u[l.XRANGEIDENTIFIERLOOSE]})(?:\\.(${u[l.XRANGEIDENTIFIERLOOSE]})(?:\\.(${u[l.XRANGEIDENTIFIERLOOSE]})(?:${u[l.PRERELEASELOOSE]})?${u[l.BUILD]}?)?)?`), y("XRANGE", `^${u[l.GTLT]}\\s*${u[l.XRANGEPLAIN]}$`), y("XRANGELOOSE", `^${u[l.GTLT]}\\s*${u[l.XRANGEPLAINLOOSE]}$`), y("COERCEPLAIN", `(^|[^\\d])(\\d{1,${r}})(?:\\.(\\d{1,${r}}))?(?:\\.(\\d{1,${r}}))?`), y("COERCE", `${u[l.COERCEPLAIN]}(?:$|[^\\d])`), y("COERCEFULL", u[l.COERCEPLAIN] + `(?:${u[l.PRERELEASE]})?(?:${u[l.BUILD]})?(?:$|[^\\d])`), y("COERCERTL", u[l.COERCE], !0), y("COERCERTLFULL", u[l.COERCEFULL], !0), y("LONETILDE", "(?:~>?)"), y("TILDETRIM", `(\\s*)${u[l.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", y("TILDE", `^${u[l.LONETILDE]}${u[l.XRANGEPLAIN]}$`), y("TILDELOOSE", `^${u[l.LONETILDE]}${u[l.XRANGEPLAINLOOSE]}$`), y("LONECARET", "(?:\\^)"), y("CARETTRIM", `(\\s*)${u[l.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", y("CARET", `^${u[l.LONECARET]}${u[l.XRANGEPLAIN]}$`), y("CARETLOOSE", `^${u[l.LONECARET]}${u[l.XRANGEPLAINLOOSE]}$`), y("COMPARATORLOOSE", `^${u[l.GTLT]}\\s*(${u[l.LOOSEPLAIN]})$|^$`), y("COMPARATOR", `^${u[l.GTLT]}\\s*(${u[l.FULLPLAIN]})$|^$`), y("COMPARATORTRIM", `(\\s*)${u[l.GTLT]}\\s*(${u[l.LOOSEPLAIN]}|${u[l.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", y("HYPHENRANGE", `^\\s*(${u[l.XRANGEPLAIN]})\\s+-\\s+(${u[l.XRANGEPLAIN]})\\s*$`), y("HYPHENRANGELOOSE", `^\\s*(${u[l.XRANGEPLAINLOOSE]})\\s+-\\s+(${u[l.XRANGEPLAINLOOSE]})\\s*$`), y("STAR", "(<|>)?=?\\s*\\*"), y("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), y("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$2, re$2.exports);
var reExports = re$2.exports;
const numeric = /^[0-9]+$/, compareIdentifiers$1 = (s, e) => {
  const r = numeric.test(s), n = numeric.test(e);
  return r && n && (s = +s, e = +e), s === e ? 0 : r && !n ? -1 : n && !r ? 1 : s < e ? -1 : 1;
}, rcompareIdentifiers = (s, e) => compareIdentifiers$1(e, s);
var identifiers = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1, { MAX_LENGTH, MAX_SAFE_INTEGER } = constants, { safeRe: re$1, t: t$1 } = reExports, parseOptions = parseOptions_1, { compareIdentifiers } = identifiers;
let SemVer$3 = class H {
  constructor(e, r) {
    if (r = parseOptions(r), e instanceof H) {
      if (e.loose === !!r.loose && e.includePrerelease === !!r.includePrerelease)
        return e;
      e = e.version;
    } else if (typeof e != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof e}".`);
    if (e.length > MAX_LENGTH)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    debug("SemVer", e, r), this.options = r, this.loose = !!r.loose, this.includePrerelease = !!r.includePrerelease;
    const n = e.trim().match(r.loose ? re$1[t$1.LOOSE] : re$1[t$1.FULL]);
    if (!n)
      throw new TypeError(`Invalid Version: ${e}`);
    if (this.raw = e, this.major = +n[1], this.minor = +n[2], this.patch = +n[3], this.major > MAX_SAFE_INTEGER || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
      throw new TypeError("Invalid patch version");
    n[4] ? this.prerelease = n[4].split(".").map((a) => {
      if (/^[0-9]+$/.test(a)) {
        const o = +a;
        if (o >= 0 && o < MAX_SAFE_INTEGER)
          return o;
      }
      return a;
    }) : this.prerelease = [], this.build = n[5] ? n[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(e) {
    if (debug("SemVer.compare", this.version, this.options, e), !(e instanceof H)) {
      if (typeof e == "string" && e === this.version)
        return 0;
      e = new H(e, this.options);
    }
    return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
  }
  compareMain(e) {
    return e instanceof H || (e = new H(e, this.options)), compareIdentifiers(this.major, e.major) || compareIdentifiers(this.minor, e.minor) || compareIdentifiers(this.patch, e.patch);
  }
  comparePre(e) {
    if (e instanceof H || (e = new H(e, this.options)), this.prerelease.length && !e.prerelease.length)
      return -1;
    if (!this.prerelease.length && e.prerelease.length)
      return 1;
    if (!this.prerelease.length && !e.prerelease.length)
      return 0;
    let r = 0;
    do {
      const n = this.prerelease[r], a = e.prerelease[r];
      if (debug("prerelease compare", r, n, a), n === void 0 && a === void 0)
        return 0;
      if (a === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === a)
        continue;
      return compareIdentifiers(n, a);
    } while (++r);
  }
  compareBuild(e) {
    e instanceof H || (e = new H(e, this.options));
    let r = 0;
    do {
      const n = this.build[r], a = e.build[r];
      if (debug("build compare", r, n, a), n === void 0 && a === void 0)
        return 0;
      if (a === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === a)
        continue;
      return compareIdentifiers(n, a);
    } while (++r);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(e, r, n) {
    switch (e) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", r, n);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", r, n);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", r, n), this.inc("pre", r, n);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", r, n), this.inc("pre", r, n);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const a = Number(n) ? 1 : 0;
        if (!r && n === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [a];
        else {
          let o = this.prerelease.length;
          for (; --o >= 0; )
            typeof this.prerelease[o] == "number" && (this.prerelease[o]++, o = -2);
          if (o === -1) {
            if (r === this.prerelease.join(".") && n === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(a);
          }
        }
        if (r) {
          let o = [r, a];
          n === !1 && (o = [r]), compareIdentifiers(this.prerelease[0], r) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = o) : this.prerelease = o;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${e}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
};
var semver = SemVer$3;
const SemVer$2 = semver, compare$6 = (s, e, r) => new SemVer$2(s, r).compare(new SemVer$2(e, r));
var compare_1 = compare$6;
const compare$5 = compare_1, eq$1 = (s, e, r) => compare$5(s, e, r) === 0;
var eq_1 = eq$1;
const compare$4 = compare_1, neq$1 = (s, e, r) => compare$4(s, e, r) !== 0;
var neq_1 = neq$1;
const compare$3 = compare_1, gt$1 = (s, e, r) => compare$3(s, e, r) > 0;
var gt_1 = gt$1;
const compare$2 = compare_1, gte$1 = (s, e, r) => compare$2(s, e, r) >= 0;
var gte_1 = gte$1;
const compare$1 = compare_1, lt$1 = (s, e, r) => compare$1(s, e, r) < 0;
var lt_1 = lt$1;
const compare = compare_1, lte$1 = (s, e, r) => compare(s, e, r) <= 0;
var lte_1 = lte$1;
const eq = eq_1, neq = neq_1, gt = gt_1, gte = gte_1, lt = lt_1, lte = lte_1, cmp = (s, e, r, n) => {
  switch (e) {
    case "===":
      return typeof s == "object" && (s = s.version), typeof r == "object" && (r = r.version), s === r;
    case "!==":
      return typeof s == "object" && (s = s.version), typeof r == "object" && (r = r.version), s !== r;
    case "":
    case "=":
    case "==":
      return eq(s, r, n);
    case "!=":
      return neq(s, r, n);
    case ">":
      return gt(s, r, n);
    case ">=":
      return gte(s, r, n);
    case "<":
      return lt(s, r, n);
    case "<=":
      return lte(s, r, n);
    default:
      throw new TypeError(`Invalid operator: ${e}`);
  }
};
var cmp_1 = cmp, comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator) return comparator;
  hasRequiredComparator = 1;
  const s = Symbol("SemVer ANY");
  class e {
    static get ANY() {
      return s;
    }
    constructor(f, h) {
      if (h = r(h), f instanceof e) {
        if (f.loose === !!h.loose)
          return f;
        f = f.value;
      }
      f = f.trim().split(/\s+/).join(" "), c("comparator", f, h), this.options = h, this.loose = !!h.loose, this.parse(f), this.semver === s ? this.value = "" : this.value = this.operator + this.semver.version, c("comp", this);
    }
    parse(f) {
      const h = this.options.loose ? n[a.COMPARATORLOOSE] : n[a.COMPARATOR], v = f.match(h);
      if (!v)
        throw new TypeError(`Invalid comparator: ${f}`);
      this.operator = v[1] !== void 0 ? v[1] : "", this.operator === "=" && (this.operator = ""), v[2] ? this.semver = new d(v[2], this.options.loose) : this.semver = s;
    }
    toString() {
      return this.value;
    }
    test(f) {
      if (c("Comparator.test", f, this.options.loose), this.semver === s || f === s)
        return !0;
      if (typeof f == "string")
        try {
          f = new d(f, this.options);
        } catch {
          return !1;
        }
      return o(f, this.operator, this.semver, this.options);
    }
    intersects(f, h) {
      if (!(f instanceof e))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new u(f.value, h).test(this.value) : f.operator === "" ? f.value === "" ? !0 : new u(this.value, h).test(f.semver) : (h = r(h), h.includePrerelease && (this.value === "<0.0.0-0" || f.value === "<0.0.0-0") || !h.includePrerelease && (this.value.startsWith("<0.0.0") || f.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && f.operator.startsWith(">") || this.operator.startsWith("<") && f.operator.startsWith("<") || this.semver.version === f.semver.version && this.operator.includes("=") && f.operator.includes("=") || o(this.semver, "<", f.semver, h) && this.operator.startsWith(">") && f.operator.startsWith("<") || o(this.semver, ">", f.semver, h) && this.operator.startsWith("<") && f.operator.startsWith(">")));
    }
  }
  comparator = e;
  const r = parseOptions_1, { safeRe: n, t: a } = reExports, o = cmp_1, c = debug_1, d = semver, u = requireRange();
  return comparator;
}
var range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;
  const s = /\s+/g;
  class e {
    constructor(p, S) {
      if (S = a(S), p instanceof e)
        return p.loose === !!S.loose && p.includePrerelease === !!S.includePrerelease ? p : new e(p.raw, S);
      if (p instanceof o)
        return this.raw = p.value, this.set = [[p]], this.formatted = void 0, this;
      if (this.options = S, this.loose = !!S.loose, this.includePrerelease = !!S.includePrerelease, this.raw = p.trim().replace(s, " "), this.set = this.raw.split("||").map((_) => this.parseRange(_.trim())).filter((_) => _.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const _ = this.set[0];
        if (this.set = this.set.filter((C) => !w(C[0])), this.set.length === 0)
          this.set = [_];
        else if (this.set.length > 1) {
          for (const C of this.set)
            if (C.length === 1 && A(C[0])) {
              this.set = [C];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let p = 0; p < this.set.length; p++) {
          p > 0 && (this.formatted += "||");
          const S = this.set[p];
          for (let _ = 0; _ < S.length; _++)
            _ > 0 && (this.formatted += " "), this.formatted += S[_].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(p) {
      const _ = ((this.options.includePrerelease && Z) | (this.options.loose && y)) + ":" + p, C = n.get(_);
      if (C)
        return C;
      const T = this.options.loose, b = T ? u[l.HYPHENRANGELOOSE] : u[l.HYPHENRANGE];
      p = p.replace(b, B(this.options.includePrerelease)), c("hyphen replace", p), p = p.replace(u[l.COMPARATORTRIM], f), c("comparator trim", p), p = p.replace(u[l.TILDETRIM], h), c("tilde trim", p), p = p.replace(u[l.CARETTRIM], v), c("caret trim", p);
      let R = p.split(" ").map(($) => F($, this.options)).join(" ").split(/\s+/).map(($) => V($, this.options));
      T && (R = R.filter(($) => (c("loose invalid filter", $, this.options), !!$.match(u[l.COMPARATORLOOSE])))), c("range list", R);
      const P = /* @__PURE__ */ new Map(), O = R.map(($) => new o($, this.options));
      for (const $ of O) {
        if (w($))
          return [$];
        P.set($.value, $);
      }
      P.size > 1 && P.has("") && P.delete("");
      const j = [...P.values()];
      return n.set(_, j), j;
    }
    intersects(p, S) {
      if (!(p instanceof e))
        throw new TypeError("a Range is required");
      return this.set.some((_) => L(_, S) && p.set.some((C) => L(C, S) && _.every((T) => C.every((b) => T.intersects(b, S)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(p) {
      if (!p)
        return !1;
      if (typeof p == "string")
        try {
          p = new d(p, this.options);
        } catch {
          return !1;
        }
      for (let S = 0; S < this.set.length; S++)
        if (K(this.set[S], p, this.options))
          return !0;
      return !1;
    }
  }
  range = e;
  const r = lrucache, n = new r(), a = parseOptions_1, o = requireComparator(), c = debug_1, d = semver, {
    safeRe: u,
    t: l,
    comparatorTrimReplace: f,
    tildeTrimReplace: h,
    caretTrimReplace: v
  } = reExports, { FLAG_INCLUDE_PRERELEASE: Z, FLAG_LOOSE: y } = constants, w = (g) => g.value === "<0.0.0-0", A = (g) => g.value === "", L = (g, p) => {
    let S = !0;
    const _ = g.slice();
    let C = _.pop();
    for (; S && _.length; )
      S = _.every((T) => C.intersects(T, p)), C = _.pop();
    return S;
  }, F = (g, p) => (c("comp", g, p), g = U(g, p), c("caret", g), g = x(g, p), c("tildes", g), g = N(g, p), c("xrange", g), g = M(g, p), c("stars", g), g), E = (g) => !g || g.toLowerCase() === "x" || g === "*", x = (g, p) => g.trim().split(/\s+/).map((S) => k(S, p)).join(" "), k = (g, p) => {
    const S = p.loose ? u[l.TILDELOOSE] : u[l.TILDE];
    return g.replace(S, (_, C, T, b, R) => {
      c("tilde", g, _, C, T, b, R);
      let P;
      return E(C) ? P = "" : E(T) ? P = `>=${C}.0.0 <${+C + 1}.0.0-0` : E(b) ? P = `>=${C}.${T}.0 <${C}.${+T + 1}.0-0` : R ? (c("replaceTilde pr", R), P = `>=${C}.${T}.${b}-${R} <${C}.${+T + 1}.0-0`) : P = `>=${C}.${T}.${b} <${C}.${+T + 1}.0-0`, c("tilde return", P), P;
    });
  }, U = (g, p) => g.trim().split(/\s+/).map((S) => I(S, p)).join(" "), I = (g, p) => {
    c("caret", g, p);
    const S = p.loose ? u[l.CARETLOOSE] : u[l.CARET], _ = p.includePrerelease ? "-0" : "";
    return g.replace(S, (C, T, b, R, P) => {
      c("caret", g, C, T, b, R, P);
      let O;
      return E(T) ? O = "" : E(b) ? O = `>=${T}.0.0${_} <${+T + 1}.0.0-0` : E(R) ? T === "0" ? O = `>=${T}.${b}.0${_} <${T}.${+b + 1}.0-0` : O = `>=${T}.${b}.0${_} <${+T + 1}.0.0-0` : P ? (c("replaceCaret pr", P), T === "0" ? b === "0" ? O = `>=${T}.${b}.${R}-${P} <${T}.${b}.${+R + 1}-0` : O = `>=${T}.${b}.${R}-${P} <${T}.${+b + 1}.0-0` : O = `>=${T}.${b}.${R}-${P} <${+T + 1}.0.0-0`) : (c("no pr"), T === "0" ? b === "0" ? O = `>=${T}.${b}.${R}${_} <${T}.${b}.${+R + 1}-0` : O = `>=${T}.${b}.${R}${_} <${T}.${+b + 1}.0-0` : O = `>=${T}.${b}.${R} <${+T + 1}.0.0-0`), c("caret return", O), O;
    });
  }, N = (g, p) => (c("replaceXRanges", g, p), g.split(/\s+/).map((S) => D(S, p)).join(" ")), D = (g, p) => {
    g = g.trim();
    const S = p.loose ? u[l.XRANGELOOSE] : u[l.XRANGE];
    return g.replace(S, (_, C, T, b, R, P) => {
      c("xRange", g, _, C, T, b, R, P);
      const O = E(T), j = O || E(b), $ = j || E(R), G = $;
      return C === "=" && G && (C = ""), P = p.includePrerelease ? "-0" : "", O ? C === ">" || C === "<" ? _ = "<0.0.0-0" : _ = "*" : C && G ? (j && (b = 0), R = 0, C === ">" ? (C = ">=", j ? (T = +T + 1, b = 0, R = 0) : (b = +b + 1, R = 0)) : C === "<=" && (C = "<", j ? T = +T + 1 : b = +b + 1), C === "<" && (P = "-0"), _ = `${C + T}.${b}.${R}${P}`) : j ? _ = `>=${T}.0.0${P} <${+T + 1}.0.0-0` : $ && (_ = `>=${T}.${b}.0${P} <${T}.${+b + 1}.0-0`), c("xRange return", _), _;
    });
  }, M = (g, p) => (c("replaceStars", g, p), g.trim().replace(u[l.STAR], "")), V = (g, p) => (c("replaceGTE0", g, p), g.trim().replace(u[p.includePrerelease ? l.GTE0PRE : l.GTE0], "")), B = (g) => (p, S, _, C, T, b, R, P, O, j, $, G) => (E(_) ? S = "" : E(C) ? S = `>=${_}.0.0${g ? "-0" : ""}` : E(T) ? S = `>=${_}.${C}.0${g ? "-0" : ""}` : b ? S = `>=${S}` : S = `>=${S}${g ? "-0" : ""}`, E(O) ? P = "" : E(j) ? P = `<${+O + 1}.0.0-0` : E($) ? P = `<${O}.${+j + 1}.0-0` : G ? P = `<=${O}.${j}.${$}-${G}` : g ? P = `<${O}.${j}.${+$ + 1}-0` : P = `<=${P}`, `${S} ${P}`.trim()), K = (g, p, S) => {
    for (let _ = 0; _ < g.length; _++)
      if (!g[_].test(p))
        return !1;
    if (p.prerelease.length && !S.includePrerelease) {
      for (let _ = 0; _ < g.length; _++)
        if (c(g[_].semver), g[_].semver !== o.ANY && g[_].semver.prerelease.length > 0) {
          const C = g[_].semver;
          if (C.major === p.major && C.minor === p.minor && C.patch === p.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
const Range = requireRange(), satisfies = (s, e, r) => {
  try {
    e = new Range(e, r);
  } catch {
    return !1;
  }
  return e.test(s);
};
var satisfies_1 = satisfies;
const semverSatisfies = /* @__PURE__ */ getDefaultExportFromCjs(satisfies_1), SemVer$1 = semver, parse$2 = (s, e, r = !1) => {
  if (s instanceof SemVer$1)
    return s;
  try {
    return new SemVer$1(s, e);
  } catch (n) {
    if (!r)
      return null;
    throw n;
  }
};
var parse_1 = parse$2;
const parse$1 = parse_1, valid = (s, e) => {
  const r = parse$1(s, e);
  return r ? r.version : null;
};
var valid_1 = valid;
const semverValid = /* @__PURE__ */ getDefaultExportFromCjs(valid_1);
class ExternalsValidator {
  /**
   * @throws Throws an error if the provided externals contain an invalid
   * version.
   */
  constructor(e) {
    this.providedExternals = e;
    for (const [r, n] of Object.entries(e))
      if (!semverValid(n))
        throw new Error(`The provided version ${JSON.stringify(n)} for the external ${JSON.stringify(r)} is invalid.`);
  }
  /**
   * Validate that the required externals are provided in a compatible version.
   *
   * @throws Throws an error if the required externals can't be satisfied.
   */
  validate(e, r) {
    for (const [n, a] of Object.entries(e)) {
      const o = this.providedExternals[n];
      if (!o)
        throw new Error(`The external dependency ${JSON.stringify(n)}${r ? ` as required by ${JSON.stringify(r)}` : ""} is not provided.`);
      if (!semverSatisfies(o, a))
        throw new Error(`The external dependency ${JSON.stringify(n)} ${r ? `as required by ${JSON.stringify(r)} in the` : "in the required"} version range ${JSON.stringify(a)} is not satisfied. The provided version is ${JSON.stringify(o)}.`);
    }
  }
}
function invalidFeatureAppModule(s, e, r) {
  let n = `The Feature App module at the url ${JSON.stringify(s)} ${e ? `with the module type ${JSON.stringify(e)}` : "with no specific module type"} is invalid. A Feature App module must have a Feature App definition as default export. A Feature App definition is an object with at least a \`create\` method.`;
  return r && r.length > 1 && !e && (n += " Hint: The provided module loader expects an optional second parameter `moduleType`. It might need to be provided for this Feature App."), n;
}
function isFeatureAppDefinition(s) {
  return typeof s != "object" || !s ? !1 : typeof s.create == "function";
}
function isFeatureAppModule(s) {
  return typeof s != "object" || !s ? !1 : isFeatureAppDefinition(s.default);
}
class FeatureAppManager {
  constructor(e, r = {}) {
    this.featureServiceRegistry = e, this.options = r, this.asyncFeatureAppDefinitions = /* @__PURE__ */ new Map(), this.featureAppDefinitionsWithRegisteredOwnFeatureServices = /* @__PURE__ */ new WeakSet(), this.featureAppRetainers = /* @__PURE__ */ new Map(), this.logger = r.logger || console;
  }
  /**
   * Load a [[FeatureAppDefinition]] using the module loader the
   * [[FeatureAppManager]] was initilized with.
   *
   * @throws Throws an error if no module loader was provided on initilization.
   *
   * @param url A URL pointing to a [[FeatureAppDefinition]] bundle in a module
   * format compatible with the module loader.
   *
   * @param moduleType The module type of the [[FeatureAppDefinition]] bundle.
   * This value can be used by the provided
   * [[FeatureAppManagerOptions.moduleLoader]].
   *
   * @returns An [[AsyncValue]] containing a promise that resolves with the
   * loaded [[FeatureAppDefinition]]. If called again with the same URL it
   * returns the same [[AsyncValue]]. The promise rejects when loading fails, or
   * when the loaded bundle doesn't export a [[FeatureAppDefinition]] as
   * default.
   */
  getAsyncFeatureAppDefinition(e, r) {
    const n = `${e}${r}`;
    let a = this.asyncFeatureAppDefinitions.get(n);
    return a || (a = this.createAsyncFeatureAppDefinition(e, r), this.asyncFeatureAppDefinitions.set(n, a)), a;
  }
  /**
   * Create a [[FeatureAppScope]] which includes validating externals, binding
   * all available Feature Service dependencies, and calling the `create` method
   * of the [[FeatureAppDefinition]].
   *
   * @throws Throws an error if Feature Services that the
   * [[FeatureAppDefinition]] provides with its `ownFeatureServices` key fail to
   * be registered.
   * @throws Throws an error if the required externals can't be satisfied.
   * @throws Throws an error if the required Feature Services can't be
   * satisfied.
   * @throws Throws an error the [[FeatureAppDefinition]]'s `create` method
   * throws.
   *
   * @param featureAppID The ID of the Feature App to create a scope for.
   * @param featureAppDefinition The definition of the Feature App to create a
   * scope for.
   *
   * @returns A [[FeatureAppScope]] for the provided Feature App ID and
   * [[FeatureAppDefinition]]. A new scope is created for every call of
   * `createFeatureAppScope`, even with the same ID and definiton.
   */
  createFeatureAppScope(e, r, n = {}) {
    const a = this.getFeatureAppRetainer(e, r, n);
    let o = !1;
    return {
      featureApp: a.featureApp,
      release: () => {
        o ? this.logger.warn(`The Feature App with the ID ${JSON.stringify(e)} has already been released for this scope.`) : (o = !0, a.release());
      }
    };
  }
  /**
   * Preload a [[FeatureAppDefinition]] using the module loader the
   * [[FeatureAppManager]] was initilized with. Useful before hydration of a
   * server rendered page to avoid render result mismatch between client and
   * server due missing [[FeatureAppDefinition]]s.
   *
   * @throws Throws an error if no module loader was provided on initilization.
   *
   * @param url A URL pointing to a [[FeatureAppDefinition]] bundle in a module
   * format compatible with the module loader.
   *
   * @param moduleType The module type of the [[FeatureAppDefinition]] bundle.
   * This value can be used by the provided
   * [[FeatureAppManagerOptions.moduleLoader]].
   */
  async preloadFeatureApp(e, r) {
    await this.getAsyncFeatureAppDefinition(e, r).promise;
  }
  createAsyncFeatureAppDefinition(e, r) {
    const { moduleLoader: n } = this.options;
    if (!n)
      throw new Error("No module loader provided.");
    return new AsyncValue(n(e, r).then((a) => {
      if (!isFeatureAppModule(a))
        throw new Error(invalidFeatureAppModule(e, r, this.options.moduleLoader));
      return this.logger.info(`The Feature App module at the url ${JSON.stringify(e)} has been successfully loaded.`), a.default;
    }));
  }
  registerOwnFeatureServices(e, r) {
    this.featureAppDefinitionsWithRegisteredOwnFeatureServices.has(r) || (r.ownFeatureServiceDefinitions && this.featureServiceRegistry.registerFeatureServices(r.ownFeatureServiceDefinitions, e), this.featureAppDefinitionsWithRegisteredOwnFeatureServices.add(r));
  }
  getFeatureAppRetainer(e, r, n) {
    let a = this.featureAppRetainers.get(e);
    return a ? a.retain() : (this.registerOwnFeatureServices(e, r), a = this.createFeatureAppRetainer(r, e, n)), a;
  }
  createFeatureAppRetainer(e, r, n) {
    var a, o;
    this.validateExternals(e, r);
    const { featureAppName: c, baseUrl: d, beforeCreate: u, config: l, done: f, parentFeatureApp: h } = n, v = this.featureServiceRegistry.bindFeatureServices(e, r, c);
    try {
      (o = (a = this.options).onBind) === null || o === void 0 || o.call(a, {
        featureAppDefinition: e,
        featureAppId: r,
        featureAppName: c,
        parentFeatureApp: h
      });
    } catch (y) {
      this.logger.error("Failed to execute onBind callback.", y);
    }
    const Z = {
      baseUrl: d,
      config: l,
      featureAppId: r,
      featureAppName: c,
      featureServices: v.featureServices,
      done: f
    };
    try {
      u == null || u(Z);
      const y = e.create(Z);
      this.logger.info(`The Feature App with the ID ${JSON.stringify(r)} has been successfully created.`);
      let w = 1;
      const A = {
        featureApp: y,
        retain: () => {
          w += 1;
        },
        release: () => {
          w -= 1, w === 0 && (this.featureAppRetainers.delete(r), v.unbind());
        }
      };
      return this.featureAppRetainers.set(r, A), A;
    } catch (y) {
      throw v.unbind(), y;
    }
  }
  validateExternals(e, r) {
    const { externalsValidator: n } = this.options;
    if (!n)
      return;
    const { dependencies: a } = e;
    a && a.externals && n.validate(a.externals, r);
  }
}
const SemVer = semver, parse = parse_1, { safeRe: re, t } = reExports, coerce = (s, e) => {
  if (s instanceof SemVer)
    return s;
  if (typeof s == "number" && (s = String(s)), typeof s != "string")
    return null;
  e = e || {};
  let r = null;
  if (!e.rtl)
    r = s.match(e.includePrerelease ? re[t.COERCEFULL] : re[t.COERCE]);
  else {
    const u = e.includePrerelease ? re[t.COERCERTLFULL] : re[t.COERCERTL];
    let l;
    for (; (l = u.exec(s)) && (!r || r.index + r[0].length !== s.length); )
      (!r || l.index + l[0].length !== r.index + r[0].length) && (r = l), u.lastIndex = l.index + l[1].length + l[2].length;
    u.lastIndex = -1;
  }
  if (r === null)
    return null;
  const n = r[2], a = r[3] || "0", o = r[4] || "0", c = e.includePrerelease && r[5] ? `-${r[5]}` : "", d = e.includePrerelease && r[6] ? `+${r[6]}` : "";
  return parse(`${n}.${a}.${o}${c}${d}`, e);
};
var coerce_1 = coerce;
const semverCoerce = /* @__PURE__ */ getDefaultExportFromCjs(coerce_1);
function featureServiceUnsupported(s, e, r, n, a) {
  return `The ${s ? "optional" : "required"} Feature Service ${JSON.stringify(e)} in the unsupported version range ${JSON.stringify(n)} could not be bound to consumer ${JSON.stringify(r)}. The supported versions are ${JSON.stringify(a)}.`;
}
function featureServiceVersionInvalid(s, e, r) {
  return `The Feature Service ${JSON.stringify(s)} could not be registered by registrant ${JSON.stringify(e)} because it defines the invalid version ${JSON.stringify(r)}.`;
}
function featureServiceDependencyVersionInvalid(s, e, r) {
  return `The ${s ? "optional" : "required"} Feature Service ${JSON.stringify(e)} in an invalid version could not be bound to consumer ${JSON.stringify(r)}.`;
}
function featureServiceNotRegistered(s, e, r) {
  return `The ${s ? "optional" : "required"} Feature Service ${JSON.stringify(e)} is not registered and therefore could not be bound to consumer ${JSON.stringify(r)}.`;
}
function featureServiceReturnedUndefined(s, e) {
  return `The Feature Service ${JSON.stringify(s)} could not be registered by registrant ${JSON.stringify(e)} because it returned undefined.`;
}
function featureServiceSuccessfullyRegistered(s, e) {
  return `The Feature Service ${JSON.stringify(s)} has been successfully registered by registrant ${JSON.stringify(e)}.`;
}
function featureServiceAlreadyRegistered(s, e) {
  return `The already registered Feature Service ${JSON.stringify(s)} could not be re-registered by registrant ${JSON.stringify(e)}.`;
}
function featureServiceSuccessfullyBound(s, e) {
  return `The required Feature Service ${JSON.stringify(s)} has been successfully bound to consumer ${JSON.stringify(e)}.`;
}
function featureServicesAlreadyBound(s) {
  return `All required Feature Services are already bound to consumer ${JSON.stringify(s)}.`;
}
function featureServiceCouldNotBeUnbound(s, e) {
  return `The required Feature Service ${JSON.stringify(s)} could not be unbound from consumer ${JSON.stringify(e)}.`;
}
function featureServiceSuccessfullyUnbound(s, e) {
  return `The required Feature Service ${JSON.stringify(s)} has been successfully unbound from consumer ${JSON.stringify(e)}.`;
}
function featureServicesAlreadyUnbound(s) {
  return `All required Feature Services are already unbound from consumer ${JSON.stringify(s)}.`;
}
var toposort$2 = { exports: {} };
toposort$2.exports = function(s) {
  return toposort(uniqueNodes(s), s);
};
toposort$2.exports.array = toposort;
function toposort(s, e) {
  var r = s.length, n = new Array(r), a = {}, o = r, c = makeOutgoingEdges(e), d = makeNodesHash(s);
  for (e.forEach(function(l) {
    if (!d.has(l[0]) || !d.has(l[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); o--; )
    a[o] || u(s[o], o, /* @__PURE__ */ new Set());
  return n;
  function u(l, f, h) {
    if (h.has(l)) {
      var v;
      try {
        v = ", node was:" + JSON.stringify(l);
      } catch {
        v = "";
      }
      throw new Error("Cyclic dependency" + v);
    }
    if (!d.has(l))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(l));
    if (!a[f]) {
      a[f] = !0;
      var Z = c.get(l) || /* @__PURE__ */ new Set();
      if (Z = Array.from(Z), f = Z.length) {
        h.add(l);
        do {
          var y = Z[--f];
          u(y, d.get(y), h);
        } while (f);
        h.delete(l);
      }
      n[--r] = l;
    }
  }
}
function uniqueNodes(s) {
  for (var e = /* @__PURE__ */ new Set(), r = 0, n = s.length; r < n; r++) {
    var a = s[r];
    e.add(a[0]), e.add(a[1]);
  }
  return Array.from(e);
}
function makeOutgoingEdges(s) {
  for (var e = /* @__PURE__ */ new Map(), r = 0, n = s.length; r < n; r++) {
    var a = s[r];
    e.has(a[0]) || e.set(a[0], /* @__PURE__ */ new Set()), e.has(a[1]) || e.set(a[1], /* @__PURE__ */ new Set()), e.get(a[0]).add(a[1]);
  }
  return e;
}
function makeNodesHash(s) {
  for (var e = /* @__PURE__ */ new Map(), r = 0, n = s.length; r < n; r++)
    e.set(s[r], r);
  return e;
}
var toposortExports = toposort$2.exports;
const toposort$1 = /* @__PURE__ */ getDefaultExportFromCjs(toposortExports);
function createTuple(s) {
  return (e) => [s, e];
}
function createDependencyEdges(s, e) {
  return Object.keys(e).map(createTuple(s));
}
function createAllDependencyEdges(s) {
  return Array.from(s.keys()).reduce((e, r) => {
    const n = s.get(r);
    if (!n)
      return e;
    const a = createDependencyEdges(r, n);
    return [...e, ...a];
  }, []);
}
function toposortDependencies(s) {
  const e = Array.from(s.keys()), r = createAllDependencyEdges(s), n = toposort$1(r);
  return n.push(...e.filter((a) => s.has(a) && n.indexOf(a) === -1)), n.reverse();
}
function mergeFeatureServiceDependencies({ dependencies: s, optionalDependencies: e }) {
  return Object.assign(Object.assign({}, s && s.featureServices), e && e.featureServices);
}
function createDependencyGraph(s) {
  const e = /* @__PURE__ */ new Map();
  for (const r of s)
    e.set(r.id, mergeFeatureServiceDependencies(r));
  return e;
}
function isOptionalFeatureServiceDependency({ optionalDependencies: s }, e) {
  return !!(s && s.featureServices && s.featureServices.hasOwnProperty(e));
}
function createProviderDefinitionsById(s) {
  const e = /* @__PURE__ */ new Map();
  for (const r of s)
    e.set(r.id, r);
  return e;
}
class FeatureServiceRegistry {
  constructor(e = {}) {
    this.options = e, this.sharedFeatureServices = /* @__PURE__ */ new Map(), this.consumerIds = /* @__PURE__ */ new Set(), this.logger = e.logger || console;
  }
  /**
   * Register a set of Feature Services to make them available for binding to
   * dependent consumers.
   *
   * @throws Throws an error if the dependencies of one of the provider
   * definitions can't be fulfilled.
   * @throws Throws an error if one of the registered Feature Services contains
   * an invalid version according to semver notation.
   *
   * @param providerDefinitions Feature Services that should be registered. A
   * Feature Service and its dependencies must either be registered together, or
   * the dependencies must have already been registered. It is not possible to
   * provide dependencies later. Sorting the provided definitions is not
   * necessary, since the registry takes care of registering the given
   * definitions in the correct order.
   * @param registrantId The ID of the entity that registers the provider
   * definitions.
   */
  registerFeatureServices(e, r) {
    const n = createProviderDefinitionsById(e), a = createDependencyGraph(e);
    for (const o of toposortDependencies(a))
      this.registerFeatureService(n, o, r);
  }
  /**
   * Bind all dependencies to a consumer.
   *
   * @throws Throws an error if non-optional dependencies can't be fulfilled.
   * @throws Throws an error if called with the same consumer ID more than once.
   *
   * @param consumerDefinition The definition of the consumer to which
   * dependencies should be bound.
   * @param consumerId The ID of the consumer to which dependencies should be
   * bound.
   * @param consumerName The name of the consumer to which dependencies should be
   * bound.
   */
  bindFeatureServices(e, r, n) {
    if (this.consumerIds.has(r))
      throw new Error(featureServicesAlreadyBound(r));
    const a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ Object.create(null), c = mergeFeatureServiceDependencies(e);
    for (const l of Object.keys(c)) {
      const f = isOptionalFeatureServiceDependency(e, l), h = c[l], v = this.bindFeatureService(l, r, n, h, { optional: f });
      v && (this.logger.info(featureServiceSuccessfullyBound(l, r)), a.set(l, v), o[l] = v.featureService);
    }
    this.consumerIds.add(r);
    let d = !1;
    return { featureServices: o, unbind: () => {
      if (d)
        throw new Error(featureServicesAlreadyUnbound(r));
      d = !0, this.consumerIds.delete(r);
      for (const [l, f] of a.entries())
        try {
          f.unbind && f.unbind(), this.logger.info(featureServiceSuccessfullyUnbound(l, r));
        } catch (h) {
          this.logger.error(featureServiceCouldNotBeUnbound(l, r), h);
        }
    } };
  }
  /**
   * Returns info about consumers and registered feature services.
   */
  getInfo() {
    return {
      consumerIds: Array.from(this.consumerIds),
      featureServices: [...this.sharedFeatureServices.entries()].map(([e, r]) => ({
        id: e,
        versions: Object.keys(r)
      }))
    };
  }
  registerFeatureService(e, r, n) {
    const a = e.get(r);
    if (!a)
      return;
    if (this.sharedFeatureServices.has(r)) {
      this.logger.warn(featureServiceAlreadyRegistered(r, n));
      return;
    }
    this.validateExternals(a, r);
    const { featureServices: o } = this.bindFeatureServices(a, r), c = a.create({ featureServices: o });
    c ? (this.validateFeatureServiceVersions(c, r, n), this.sharedFeatureServices.set(r, c), this.logger.info(featureServiceSuccessfullyRegistered(r, n))) : this.logger.info(featureServiceReturnedUndefined(r, n));
  }
  bindFeatureService(e, r, n, a, { optional: o }) {
    const c = a && semverCoerce(a);
    if (!c) {
      const v = featureServiceDependencyVersionInvalid(o, e, r);
      if (o) {
        this.logger.info(v);
        return;
      }
      throw new Error(v);
    }
    const d = `^${c.version}`, u = this.sharedFeatureServices.get(e);
    if (!u) {
      const v = featureServiceNotRegistered(o, e, r);
      if (o) {
        this.logger.info(v);
        return;
      }
      throw new Error(v);
    }
    const l = Object.keys(u), f = l.find((v) => semverSatisfies(v, d)), h = f ? u[f] : void 0;
    if (!h) {
      const v = featureServiceUnsupported(o, e, r, d, l);
      if (o) {
        this.logger.info(v);
        return;
      }
      throw new Error(v);
    }
    return h(r, n);
  }
  validateExternals(e, r) {
    const { externalsValidator: n } = this.options;
    if (!n)
      return;
    const { dependencies: a } = e;
    a && a.externals && n.validate(a.externals, r);
  }
  validateFeatureServiceVersions(e, r, n) {
    for (const a of Object.keys(e))
      if (!semverValid(a))
        throw new Error(featureServiceVersionInvalid(r, n, a));
  }
}
function createFeatureHub(s, e = {}) {
  const { featureServiceDefinitions: r, featureServiceDependencies: n, providedExternals: a, moduleLoader: o, logger: c, onBind: d } = e;
  let u;
  a && (u = new ExternalsValidator(a));
  const l = new FeatureServiceRegistry({
    externalsValidator: u,
    logger: c
  }), f = {
    dependencies: { featureServices: n }
  };
  r && l.registerFeatureServices(r, s);
  const h = new FeatureAppManager(l, {
    externalsValidator: u,
    moduleLoader: o,
    logger: c,
    onBind: d
  }), { featureServices: v } = l.bindFeatureServices(f, s);
  return { featureAppManager: h, featureServiceRegistry: l, featureServices: v };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(s) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (s[n] = r[n]);
    }
    return s;
  }, _extends.apply(null, arguments);
}
var Action;
(function(s) {
  s.Pop = "POP", s.Push = "PUSH", s.Replace = "REPLACE";
})(Action || (Action = {}));
var readOnly = process.env.NODE_ENV !== "production" ? function(s) {
  return Object.freeze(s);
} : function(s) {
  return s;
};
function warning(s, e) {
  if (!s) {
    typeof console < "u" && console.warn(e);
    try {
      throw new Error(e);
    } catch {
    }
  }
}
var BeforeUnloadEventType = "beforeunload", PopStateEventType = "popstate";
function createBrowserHistory(s) {
  s === void 0 && (s = {});
  var e = s, r = e.window, n = r === void 0 ? document.defaultView : r, a = n.history;
  function o() {
    var I = n.location, N = I.pathname, D = I.search, M = I.hash, V = a.state || {};
    return [V.idx, readOnly({
      pathname: N,
      search: D,
      hash: M,
      state: V.usr || null,
      key: V.key || "default"
    })];
  }
  var c = null;
  function d() {
    if (c)
      Z.call(c), c = null;
    else {
      var I = Action.Pop, N = o(), D = N[0], M = N[1];
      if (Z.length)
        if (D != null) {
          var V = f - D;
          V && (c = {
            action: I,
            location: M,
            retry: function() {
              k(V * -1);
            }
          }, k(V));
        } else
          process.env.NODE_ENV !== "production" && warning(
            !1,
            // TODO: Write up a doc that explains our blocking strategy in
            // detail and link to it here so people can understand better what
            // is going on and how to avoid it.
            "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation."
          );
      else
        F(I);
    }
  }
  n.addEventListener(PopStateEventType, d);
  var u = Action.Pop, l = o(), f = l[0], h = l[1], v = createEvents(), Z = createEvents();
  f == null && (f = 0, a.replaceState(_extends({}, a.state, {
    idx: f
  }), ""));
  function y(I) {
    return typeof I == "string" ? I : createPath(I);
  }
  function w(I, N) {
    return N === void 0 && (N = null), readOnly(_extends({
      pathname: h.pathname,
      hash: "",
      search: ""
    }, typeof I == "string" ? parsePath(I) : I, {
      state: N,
      key: createKey$1()
    }));
  }
  function A(I, N) {
    return [{
      usr: I.state,
      key: I.key,
      idx: N
    }, y(I)];
  }
  function L(I, N, D) {
    return !Z.length || (Z.call({
      action: I,
      location: N,
      retry: D
    }), !1);
  }
  function F(I) {
    u = I;
    var N = o();
    f = N[0], h = N[1], v.call({
      action: u,
      location: h
    });
  }
  function E(I, N) {
    var D = Action.Push, M = w(I, N);
    function V() {
      E(I, N);
    }
    if (L(D, M, V)) {
      var B = A(M, f + 1), K = B[0], g = B[1];
      try {
        a.pushState(K, "", g);
      } catch {
        n.location.assign(g);
      }
      F(D);
    }
  }
  function x(I, N) {
    var D = Action.Replace, M = w(I, N);
    function V() {
      x(I, N);
    }
    if (L(D, M, V)) {
      var B = A(M, f), K = B[0], g = B[1];
      a.replaceState(K, "", g), F(D);
    }
  }
  function k(I) {
    a.go(I);
  }
  var U = {
    get action() {
      return u;
    },
    get location() {
      return h;
    },
    createHref: y,
    push: E,
    replace: x,
    go: k,
    back: function() {
      k(-1);
    },
    forward: function() {
      k(1);
    },
    listen: function(N) {
      return v.push(N);
    },
    block: function(N) {
      var D = Z.push(N);
      return Z.length === 1 && n.addEventListener(BeforeUnloadEventType, promptBeforeUnload), function() {
        D(), Z.length || n.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
      };
    }
  };
  return U;
}
function createMemoryHistory(s) {
  s === void 0 && (s = {});
  var e = s, r = e.initialEntries, n = r === void 0 ? ["/"] : r, a = e.initialIndex, o = n.map(function(E) {
    var x = readOnly(_extends({
      pathname: "/",
      search: "",
      hash: "",
      state: null,
      key: createKey$1()
    }, typeof E == "string" ? parsePath(E) : E));
    return process.env.NODE_ENV !== "production" && warning(x.pathname.charAt(0) === "/", "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(E) + ")"), x;
  }), c = clamp(a ?? o.length - 1, 0, o.length - 1), d = Action.Pop, u = o[c], l = createEvents(), f = createEvents();
  function h(E) {
    return typeof E == "string" ? E : createPath(E);
  }
  function v(E, x) {
    return x === void 0 && (x = null), readOnly(_extends({
      pathname: u.pathname,
      search: "",
      hash: ""
    }, typeof E == "string" ? parsePath(E) : E, {
      state: x,
      key: createKey$1()
    }));
  }
  function Z(E, x, k) {
    return !f.length || (f.call({
      action: E,
      location: x,
      retry: k
    }), !1);
  }
  function y(E, x) {
    d = E, u = x, l.call({
      action: d,
      location: u
    });
  }
  function w(E, x) {
    var k = Action.Push, U = v(E, x);
    function I() {
      w(E, x);
    }
    process.env.NODE_ENV !== "production" && warning(u.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.push(" + JSON.stringify(E) + ")"), Z(k, U, I) && (c += 1, o.splice(c, o.length, U), y(k, U));
  }
  function A(E, x) {
    var k = Action.Replace, U = v(E, x);
    function I() {
      A(E, x);
    }
    process.env.NODE_ENV !== "production" && warning(u.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(E) + ")"), Z(k, U, I) && (o[c] = U, y(k, U));
  }
  function L(E) {
    var x = clamp(c + E, 0, o.length - 1), k = Action.Pop, U = o[x];
    function I() {
      L(E);
    }
    Z(k, U, I) && (c = x, y(k, U));
  }
  var F = {
    get index() {
      return c;
    },
    get action() {
      return d;
    },
    get location() {
      return u;
    },
    createHref: h,
    push: w,
    replace: A,
    go: L,
    back: function() {
      L(-1);
    },
    forward: function() {
      L(1);
    },
    listen: function(x) {
      return l.push(x);
    },
    block: function(x) {
      return f.push(x);
    }
  };
  return F;
}
function clamp(s, e, r) {
  return Math.min(Math.max(s, e), r);
}
function promptBeforeUnload(s) {
  s.preventDefault(), s.returnValue = "";
}
function createEvents() {
  var s = [];
  return {
    get length() {
      return s.length;
    },
    push: function(r) {
      return s.push(r), function() {
        s = s.filter(function(n) {
          return n !== r;
        });
      };
    },
    call: function(r) {
      s.forEach(function(n) {
        return n && n(r);
      });
    }
  };
}
function createKey$1() {
  return Math.random().toString(36).substr(2, 8);
}
function createPath(s) {
  var e = s.pathname, r = e === void 0 ? "/" : e, n = s.search, a = n === void 0 ? "" : n, o = s.hash, c = o === void 0 ? "" : o;
  return a && a !== "?" && (r += a.charAt(0) === "?" ? a : "?" + a), c && c !== "#" && (r += c.charAt(0) === "#" ? c : "#" + c), r;
}
function parsePath(s) {
  var e = {};
  if (s) {
    var r = s.indexOf("#");
    r >= 0 && (e.hash = s.substr(r), s = s.substr(0, r));
    var n = s.indexOf("?");
    n >= 0 && (e.search = s.substr(n), s = s.substr(0, n)), s && (e.pathname = s);
  }
  return e;
}
function isAbsolute$1(s) {
  return s.charAt(0) === "/";
}
function spliceOne(s, e) {
  for (var r = e, n = r + 1, a = s.length; n < a; r += 1, n += 1)
    s[r] = s[n];
  s.pop();
}
function resolvePathname(s, e) {
  e === void 0 && (e = "");
  var r = s && s.split("/") || [], n = e && e.split("/") || [], a = s && isAbsolute$1(s), o = e && isAbsolute$1(e), c = a || o;
  if (s && isAbsolute$1(s) ? n = r : r.length && (n.pop(), n = n.concat(r)), !n.length) return "/";
  var d;
  if (n.length) {
    var u = n[n.length - 1];
    d = u === "." || u === ".." || u === "";
  } else
    d = !1;
  for (var l = 0, f = n.length; f >= 0; f--) {
    var h = n[f];
    h === "." ? spliceOne(n, f) : h === ".." ? (spliceOne(n, f), l++) : l && (spliceOne(n, f), l--);
  }
  if (!c) for (; l--; l) n.unshift("..");
  c && n[0] !== "" && (!n[0] || !isAbsolute$1(n[0])) && n.unshift("");
  var v = n.join("/");
  return d && v.substr(-1) !== "/" && (v += "/"), v;
}
function createHistoryPath(s, e = "") {
  const r = typeof s == "string" ? s : createPath(s), { pathname: n = "", search: a = "", hash: o = "" } = parsePath(r.startsWith("/") ? r : resolvePathname(r, e));
  return { pathname: n, search: a, hash: o };
}
function createKey() {
  return Math.random().toString(36).slice(2, 8);
}
class HistoryMultiplexer {
  constructor(e, r) {
    this.rootHistory = e, this.rootLocationTransformer = r, this.rootHistoryV2 = {
      get length() {
        try {
          return window.history.length;
        } catch {
          return 1;
        }
      },
      get location() {
        return e.location;
      },
      push(n) {
        const { pathname: a, search: o, hash: c, state: d } = n;
        e.push({ pathname: a, search: o, hash: c }, d);
      },
      replace(n) {
        const { pathname: a, search: o, hash: c, state: d } = n;
        e.replace({ pathname: a, search: o, hash: c }, d);
      },
      createHref(n) {
        return e.createHref(n);
      },
      listen(n) {
        return e.listen(({ location: a, action: o }) => n(a, o));
      }
    };
  }
  get rootLocation() {
    return this.rootHistory.location;
  }
  push(e, r) {
    const { pathname: n, search: a, hash: o, state: c } = this.createRootLocation(e, r);
    this.rootHistory.push({ pathname: n, search: a, hash: o }, c);
  }
  replace(e, r) {
    const { pathname: n, search: a, hash: o, state: c } = this.createRootLocation(e, r);
    this.rootHistory.replace({ pathname: n, search: a, hash: o }, c);
  }
  createHref(e, r) {
    const { pathname: n, search: a, hash: o } = this.createRootLocation(e, r);
    return this.rootHistory.createHref({ pathname: n, search: a, hash: o });
  }
  getConsumerLocation(e) {
    var r;
    const n = this.rootLocationTransformer.getConsumerPathFromRootLocation(this.rootLocation, e) || "/", { state: a, key: o } = ((r = this.rootLocation.state) === null || r === void 0 ? void 0 : r[e]) || {
      state: void 0,
      key: createKey()
    };
    return Object.assign(Object.assign({}, createHistoryPath(parsePath(n))), {
      state: a,
      key: o
    });
  }
  listenForRootLocationChange(e) {
    return this.rootHistory.listen(({ action: r }) => {
      e(r);
    });
  }
  createNewRootLocationForMultipleConsumers(...e) {
    let r = { pathname: "/" };
    if (this.rootLocationTransformer.createNewRootLocationForMultipleConsumers)
      r = this.rootLocationTransformer.createNewRootLocationForMultipleConsumers(...e);
    else
      for (const a of e)
        r = this.rootLocationTransformer.createRootLocation(r, a.location, a.historyKey);
    const n = {};
    for (const { historyKey: a, state: o } of e)
      n[a] = { state: o, key: createKey() };
    return Object.assign(Object.assign({}, createHistoryPath(r)), { state: n });
  }
  createRootLocation(e, r) {
    const n = this.rootLocationTransformer.createRootLocation(this.rootLocation, r, e), { state: a, key: o = createKey() } = r;
    return Object.assign(Object.assign({}, createHistoryPath(n)), { state: Object.assign(Object.assign({}, this.rootLocation.state), { [e]: { state: a, key: o } }) });
  }
}
function createHistoryMultiplexers(s, e) {
  let r, n;
  return {
    get browserHistoryMultiplexer() {
      return r || (r = new HistoryMultiplexer(createBrowserHistory(), e)), r;
    },
    get staticHistoryMultiplexer() {
      if (!n) {
        if (!s.serverRequest)
          throw new Error("Static history can not be created without a server request.");
        n = new HistoryMultiplexer(createMemoryHistory({
          initialEntries: [createPathFromUrl(s.serverRequest.url)],
          initialIndex: 0
        }), e);
      }
      return n;
    }
  };
}
function createPathFromUrl(s) {
  if (isAbsolute(s)) {
    const { pathname: e, search: r } = new URL(s);
    return { pathname: e, search: r };
  }
  return parsePath(s);
}
function isAbsolute(s) {
  return /^https?:\/\//.test(s);
}
var fastDeepEqual = function s(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var n, a, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length) return !1;
      for (a = n; a-- !== 0; )
        if (!s(e[a], r[a])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === r.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(r).length) return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[a])) return !1;
    for (a = n; a-- !== 0; ) {
      var c = o[a];
      if (!s(e[c], r[c])) return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
};
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqual);
class ConsumerHistory {
  constructor(e, r, n) {
    this.context = e, this.historyKey = r, this.historyMultiplexer = n, this.action = Action.Pop;
    const { pathname: a, search: o, hash: c, state: d, key: u } = n.getConsumerLocation(r);
    this.location = {
      pathname: a.startsWith("/") ? a : `/${a}`,
      search: o,
      hash: c,
      state: d,
      key: u
    }, this.push = this.push.bind(this), this.replace = this.replace.bind(this), this.go = this.go.bind(this), this.back = this.back.bind(this), this.forward = this.forward.bind(this), this.block = this.block.bind(this), this.createHref = this.createHref.bind(this);
  }
  push(e, r) {
    this.location = this.createLocation(e, r), this.historyMultiplexer.push(this.historyKey, this.location), this.action = Action.Push;
  }
  replace(e, r) {
    this.location = this.createLocation(e, r), this.historyMultiplexer.replace(this.historyKey, this.location), this.action = Action.Replace;
  }
  go() {
    this.context.logger.warn("history.go() is not supported.");
  }
  back() {
    this.context.logger.warn("history.back() is not supported.");
  }
  forward() {
    this.context.logger.warn("history.forward() is not supported.");
  }
  block() {
    return this.context.logger.warn("history.block() is not supported."), () => {
    };
  }
  createHref(e) {
    return this.historyMultiplexer.createHref(this.historyKey, createHistoryPath(e, createPath(this.location)));
  }
  createLocation(e, r) {
    return Object.assign(Object.assign({}, createHistoryPath(e, this.location.pathname)), { state: r, key: createKey() });
  }
}
class BrowserConsumerHistory extends ConsumerHistory {
  constructor(e, r, n) {
    super(e, r, n), this.listeners = /* @__PURE__ */ new Set(), this.unregisterCallbacks = [], this.browserUnregister = n.listenForRootLocationChange((a) => {
      this.handleRootLocationChange(a);
    }), this.listen = this.listen.bind(this), this.push = this.push.bind(this), this.replace = this.replace.bind(this);
  }
  destroy() {
    this.browserUnregister(), this.unregisterCallbacks.forEach((e) => e());
  }
  listen(e) {
    this.listeners.add(e);
    const r = () => {
      this.listeners.delete(e);
    };
    return this.unregisterCallbacks.push(r), r;
  }
  push(e, r) {
    super.push(e, r), this.notifyListeners();
  }
  replace(e, r) {
    super.replace(e, r), this.notifyListeners();
  }
  notifyListeners() {
    for (const e of this.listeners)
      e({ location: this.location, action: this.action });
  }
  handleRootLocationChange(e) {
    const r = this.historyMultiplexer.getConsumerLocation(this.historyKey);
    this.matches(r) || (this.location = r, this.action = e, this.notifyListeners());
  }
  matches(e) {
    return createPath(e) !== createPath(this.location) ? !1 : equal(e.state, this.location.state);
  }
}
function createHistoryV4Adapter(s, e) {
  return {
    get length() {
      return typeof window > "u" ? 1 : window.history.length;
    },
    get action() {
      return e.action;
    },
    get location() {
      return e.location;
    },
    push: (r, n) => {
      if (typeof r == "string")
        e.push(r, n);
      else {
        const { pathname: a, search: o, hash: c, state: d } = r;
        e.push({ pathname: a, search: o, hash: c }, d);
      }
    },
    replace: (r, n) => {
      if (typeof r == "string")
        e.replace(r, n);
      else {
        const { pathname: a, search: o, hash: c, state: d } = r;
        e.replace({ pathname: a, search: o, hash: c }, d);
      }
    },
    go: () => {
      s.logger.warn("history.go() is not supported.");
    },
    goBack: () => {
      s.logger.warn("history.goBack() is not supported.");
    },
    goForward: () => {
      s.logger.warn("history.goForward() is not supported.");
    },
    block: () => (s.logger.warn("history.block() is not supported."), () => {
    }),
    listen: (r) => e.listen(({ location: n, action: a }) => r(n, a)),
    createHref: (r) => e.createHref(r)
  };
}
class StaticConsumerHistory extends ConsumerHistory {
  constructor(e, r, n) {
    super(e, r, n), this.listen = this.listen.bind(this);
  }
  listen() {
    return this.context.logger.warn("history.listen() is not supported."), () => {
    };
  }
}
function createHistoryServiceV1Binder(s, e, r) {
  const { getHistoryKey: n } = r;
  return (a, o) => {
    const c = n({ consumerId: a, consumerName: o });
    let d = () => {
    }, u, l;
    return { featureService: {
      createBrowserHistory: () => {
        if (u)
          s.logger.warn(`createBrowserHistory was called multiple times by consumer ${JSON.stringify(a)}. Returning the same history instance as before.`);
        else {
          const v = new BrowserConsumerHistory(s, c, e.browserHistoryMultiplexer);
          d = () => v.destroy(), u = createHistoryV4Adapter(s, v);
        }
        return u;
      },
      createStaticHistory: () => (l ? s.logger.warn(`createStaticHistory was called multiple times by consumer ${JSON.stringify(a)}. Returning the same history instance as before.`) : l = createHistoryV4Adapter(s, new StaticConsumerHistory(s, c, e.staticHistoryMultiplexer)), l),
      get staticRootLocation() {
        return e.staticHistoryMultiplexer.rootLocation;
      }
    }, unbind: () => {
      d();
    } };
  };
}
function createHistoryServiceV2(s, e, r, n) {
  return {
    historyKey: e,
    history: createHistoryV4Adapter(s, r),
    rootHistory: n.rootHistoryV2,
    createNewRootLocationForMultipleConsumers: (...a) => n.createNewRootLocationForMultipleConsumers(...a.map(({ historyKey: o, location: { pathname: c, search: d, hash: u, state: l } }) => ({
      historyKey: o,
      location: { pathname: c, search: d, hash: u },
      state: l
    })))
  };
}
function createBrowserHistoryServiceV2Binding(s, e, r) {
  const n = new BrowserConsumerHistory(s, r, e.browserHistoryMultiplexer);
  return {
    featureService: createHistoryServiceV2(s, r, n, e.browserHistoryMultiplexer),
    unbind: () => {
      n.destroy();
    }
  };
}
function createStaticHistoryServiceV2Binding(s, e, r) {
  const n = new StaticConsumerHistory(s, r, e.staticHistoryMultiplexer);
  return {
    featureService: createHistoryServiceV2(s, r, n, e.staticHistoryMultiplexer)
  };
}
function createHistoryServiceV2Binder(s, e, r) {
  const { mode: n, getHistoryKey: a } = r;
  return (o, c) => {
    const d = a({ consumerId: o, consumerName: c });
    return n === "browser" ? createBrowserHistoryServiceV2Binding(s, e, d) : createStaticHistoryServiceV2Binding(s, e, d);
  };
}
function createHistoryServiceV3(s, e, r) {
  return {
    historyKey: s,
    history: e,
    rootHistory: r.rootHistory,
    createNewRootLocationForMultipleConsumers: (...n) => r.createNewRootLocationForMultipleConsumers(...n)
  };
}
function createBrowserHistoryServiceV3Binding(s, e, r) {
  const n = new BrowserConsumerHistory(s, r, e.browserHistoryMultiplexer);
  return {
    featureService: createHistoryServiceV3(r, n, e.browserHistoryMultiplexer),
    unbind: () => {
      n.destroy();
    }
  };
}
function createStaticHistoryServiceV3Binding(s, e, r) {
  const n = new StaticConsumerHistory(s, r, e.staticHistoryMultiplexer);
  return {
    featureService: createHistoryServiceV3(r, n, e.staticHistoryMultiplexer)
  };
}
function createHistoryServiceV3Binder(s, e, r) {
  const { mode: n, getHistoryKey: a } = r;
  return (o, c) => {
    const d = a({ consumerId: o, consumerName: c });
    return n === "browser" ? createBrowserHistoryServiceV3Binding(s, e, d) : createStaticHistoryServiceV3Binding(s, e, d);
  };
}
function createHistoryServiceContext(s) {
  const e = s["s2:logger"] || console, r = s["s2:server-request"];
  return { logger: e, serverRequest: r };
}
const URLSearchParamsPonyfill = typeof URLSearchParams > "u" && typeof window > "u" ? (
  // tslint:disable-next-line:no-eval https://stackoverflow.com/a/41063795/10385541
  eval("require")("url").URLSearchParams
) : URLSearchParams;
function encodeConsumerPaths(s) {
  return JSON.stringify(s);
}
function decodeConsumerPaths(s) {
  return JSON.parse(s);
}
function addConsumerPath(s, e, r) {
  return encodeConsumerPaths(Object.assign(Object.assign({}, decodeConsumerPaths(s || "{}")), { [e]: r }));
}
function getConsumerPath(s, e) {
  return decodeConsumerPaths(s)[e];
}
function createSearchParams(s) {
  return new URLSearchParamsPonyfill(s.search);
}
function serializeSearchParams(s) {
  return `?${s.toString()}`;
}
function createRootLocationForPrimaryConsumer(s, e, r) {
  const n = createSearchParams(s), a = createSearchParams(e);
  if (a.has(r))
    throw new Error(`Primary consumer tried to set query parameter ${JSON.stringify(r)} which is reserverd for consumer paths.`);
  const o = n.get(r);
  let c;
  o ? (a.set(r, o), c = serializeSearchParams(a)) : c = e.search;
  const { pathname: d, hash: u } = e;
  return { pathname: d, search: c, hash: u };
}
function createRootLocationForOtherConsumer(s, e, r, n) {
  const a = createSearchParams(s), o = a.get(n), c = addConsumerPath(o, r, createPath(e));
  return a.set(n, c), {
    pathname: s.pathname,
    search: serializeSearchParams(a),
    hash: s.hash
  };
}
function createRootLocationTransformer(s) {
  return {
    getConsumerPathFromRootLocation: (e, r) => {
      const { consumerPathsQueryParamName: n, primaryConsumerHistoryKey: a } = s, o = r === a, c = createSearchParams(e);
      if (o) {
        c.delete(n);
        const { pathname: u, hash: l } = e, f = serializeSearchParams(c);
        return createPath({ pathname: u, search: f, hash: l });
      }
      const d = c.get(n);
      if (d)
        return getConsumerPath(d, r);
    },
    createRootLocation: (e, r, n) => {
      const { consumerPathsQueryParamName: a, primaryConsumerHistoryKey: o } = s;
      return n === o ? createRootLocationForPrimaryConsumer(e, r, a) : createRootLocationForOtherConsumer(e, r, n, a);
    }
  };
}
function defineHistoryService(s, e = {}) {
  const { mode: r = "browser", getHistoryKey: n = ({ consumerId: a }) => a } = e;
  return {
    id: "s2:history",
    optionalDependencies: {
      featureServices: {
        "s2:logger": "^1.0.0",
        "s2:server-request": "^1.0.0"
      }
    },
    create: (a) => {
      const o = createHistoryServiceContext(a.featureServices), c = createHistoryMultiplexers(o, s);
      return {
        "1.0.0": createHistoryServiceV1Binder(o, c, {
          getHistoryKey: n
        }),
        "2.0.0": createHistoryServiceV2Binder(o, c, {
          mode: r,
          getHistoryKey: n
        }),
        "3.0.0": createHistoryServiceV3Binder(o, c, {
          mode: r,
          getHistoryKey: n
        })
      };
    }
  };
}
function defineLogger(s = () => console) {
  return {
    id: "s2:logger",
    create: () => ({
      "1.0.0": (e, r) => ({
        featureService: s(e, r)
      })
    })
  };
}
async function loadComponent() {
  await __webpack_init_sharing__("default");
  const s = window.__feature_hub_feature_app_module_container__;
  if (!s)
    throw new Error('The name in the ModuleFederationPlugin must be "__feature_hub_feature_app_module_container__".');
  return window.__feature_hub_feature_app_module_container__ = void 0, await s.init(__webpack_share_scopes__.default), (await s.get("featureAppModule"))();
}
async function loadFederatedModule(s) {
  return new Promise((e, r) => {
    const n = document.createElement("script");
    n.src = s, n.type = "text/javascript", n.async = !0, n.onload = () => {
      loadComponent().then(e).catch(r), document.head.removeChild(n);
    }, n.onerror = () => {
      r(new Error("Could not load federated module.")), document.head.removeChild(n);
    }, document.head.appendChild(n);
  });
}
function createFragment(s) {
  const { children: e } = s, r = document.createDocumentFragment();
  if (Array.isArray(e))
    for (const n of e)
      r.appendChild(createFragment({ children: n }));
  else e instanceof Node ? r.appendChild(e) : (typeof e == "number" || typeof e == "string") && r.append(`${e}`);
  return r;
}
const elementByKey = /* @__PURE__ */ new WeakMap();
function createElementFactory(s, e) {
  return ({ children: r, key: n, ...a }) => {
    const o = (n && elementByKey.get(n)) ?? document.createElement(s);
    if (n) {
      if (o.tagName !== s.toUpperCase())
        throw new Error(`cannot use key with tag: ${s}`);
      elementByKey.set(n, o);
    }
    for (const c of o.getAttributeNames())
      o.removeAttribute(c);
    for (const [c, d] of Object.entries(a))
      switch (typeof d) {
        case "boolean": {
          d === !0 && o.setAttribute(c, "");
          break;
        }
        case "number":
        case "string": {
          o.setAttribute(c, `${d}`);
          break;
        }
        default:
          if (d != null)
            throw new TypeError(`cannot set attribute: ${c}`);
      }
    return e(o, Array.from(createFragment({ children: r }).childNodes)), o;
  };
}
function createElement(s, e, ...r) {
  return (typeof s == "string" ? createElementFactory(s, replaceChildren) : s)({ ...e, children: r });
}
function replaceChildren(s, e) {
  s.replaceChildren(...e);
}
/*! js-cookie v3.0.5 | MIT */
function assign(s) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      s[n] = r[n];
  }
  return s;
}
var defaultConverter = {
  read: function(s) {
    return s[0] === '"' && (s = s.slice(1, -1)), s.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(s) {
    return encodeURIComponent(s).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(s, e) {
  function r(a, o, c) {
    if (!(typeof document > "u")) {
      c = assign({}, e, c), typeof c.expires == "number" && (c.expires = new Date(Date.now() + c.expires * 864e5)), c.expires && (c.expires = c.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var d = "";
      for (var u in c)
        c[u] && (d += "; " + u, c[u] !== !0 && (d += "=" + c[u].split(";")[0]));
      return document.cookie = a + "=" + s.write(o, a) + d;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], c = {}, d = 0; d < o.length; d++) {
        var u = o[d].split("="), l = u.slice(1).join("=");
        try {
          var f = decodeURIComponent(u[0]);
          if (c[f] = s.read(l, f), a === f)
            break;
        } catch {
        }
      }
      return a ? c[a] : c;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(a, o) {
        r(
          a,
          "",
          assign({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return init(this.converter, assign({}, this.attributes, a));
      },
      withConverter: function(a) {
        return init(assign({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(s) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
function parseAdbContextCookie(s) {
  const e = api.get(s);
  if (e)
    try {
      const r = JSON.parse(e);
      return isObject(r) && typeof r.key == "string" && isObject(r.adbContext) && typeof r.adbContext.outletId == "string" && typeof r.adbContext.referrerPath == "string" && typeof r.adbContext.hasCustomer == "boolean" ? r : void 0;
    } catch {
    }
}
function isObject(s) {
  return typeof s == "object" && s !== null;
}
function defineAdbContextService(s) {
  const { cookieName: e, resetPathname: r } = s;
  return {
    id: "adb-context-service",
    create: () => {
      const n = parseAdbContextCookie(e);
      window.addEventListener("pageshow", (o) => {
        var c;
        o.persisted && (n == null ? void 0 : n.key) !== ((c = parseAdbContextCookie(e)) === null || c === void 0 ? void 0 : c.key) && location.reload();
      });
      const a = () => {
        const { pathname: o, search: c, hash: d } = document.location, u = createElement(
          "form",
          { action: r, method: "POST" },
          createElement("input", { name: "redirectPath", type: "hidden", value: `${o}${c}${d}` })
        );
        document.body.appendChild(u), u.submit(), u.remove();
      };
      return {
        "1.0.0": () => ({
          featureService: {
            isAdbContextSet: !!n,
            resetAdbContext: a
          }
        }),
        "2.0.0": () => ({
          featureService: {
            adbContext: n == null ? void 0 : n.adbContext,
            resetAdbContext: a
          }
        })
      };
    }
  };
}
function defineEndpointDirectory(s) {
  const { envName: e, rotatingVerifySecret: r, preview: n } = s;
  return {
    id: "endpoint-directory",
    optionalDependencies: {
      featureServices: {
        "s2:logger": "^1.0.0"
      }
    },
    create: ({ featureServices: a }) => {
      const { "s2:logger": o = console } = a;
      return {
        "1.0.0": (c, d) => (assertIsEnvNameV1(e, c, d), o.warn(`DEPRECATED: Version 1.0.0 of the endpoint directory is deprecated. The consumer ${printConsumerInfo({ consumerId: c, consumerName: d })} should use 3.0.0 instead.`), {
          featureService: {
            envName: e,
            preview: n,
            restApiAuthHeader: r
          }
        }),
        "2.0.0": (c, d) => (assertIsEnvNameV1(e, c, d), o.warn(`DEPRECATED: Version 2.0.0 of the endpoint directory is deprecated. The consumer ${printConsumerInfo({ consumerId: c, consumerName: d })} should use 3.0.0 instead.`), { featureService: { envName: e, preview: n, rotatingVerifySecret: r } }),
        "3.0.0": () => ({ featureService: s })
      };
    }
  };
}
function assertIsEnvNameV1(s, e, r) {
  if (s === "sit")
    throw new Error(`The consumer ${printConsumerInfo({
      consumerId: e,
      consumerName: r
    })} must use 3.0.0 of the endpoint directory to support the SIT environment.`);
}
function printConsumerInfo({ consumerId: s, consumerName: e }) {
  return `"${s}"${e ? ` ("${e}")` : ""}`;
}
const virtualMarketIds = [
  "fm",
  "sb"
  // playground
];
function getCountryCode(s) {
  return virtualMarketIds.includes(s) ? "DE" : s.toUpperCase();
}
function getCurrency(s) {
  switch (getCountryCode(s)) {
    case "CH":
      return "CHF";
    case "GB":
      return "GBP";
    case "SE":
      return "SEK";
    default:
      return "EUR";
  }
}
function getLanguage(s) {
  return s.slice(0, 2);
}
function createBinderV1(s) {
  const { marketId: e, languageTag: r } = s.locale, n = {
    countryCode: getCountryCode(e),
    language: getLanguage(r),
    currency: getCurrency(e)
  };
  return (a, o) => (s.logger.warn(`DEPRECATED: Version 1.0.0 of the locale service is deprecated. The consumer "${a}"${o ? ` ("${o}")` : ""} should use 3.0.0 instead.`), { featureService: n });
}
function createBinderV2(s) {
  const e = /* @__PURE__ */ new Set();
  let r = createLocaleV2(s.locale);
  return s.subscribe((n) => {
    r = createLocaleV2(n);
    for (const a of e)
      a(r);
  }), (n, a) => (s.logger.warn(`DEPRECATED: Version 2.x.x of the locale service is deprecated. The consumer "${n}"${a ? ` ("${a}")` : ""} should use 3.0.0 instead.`), {
    featureService: {
      getLocale: () => r,
      subscribe: (o) => (e.add(o), () => {
        e.delete(o);
      })
    }
  });
}
function createLocaleV2(s) {
  const { marketId: e, languageTag: r } = s, n = getCountryCode(e);
  return {
    countryCode: n,
    language: getLanguage(r),
    languageTag: r,
    currency: getCurrency(e),
    baseSiteId: `smart-${n.toLocaleLowerCase()}`,
    marketId: e
  };
}
function createBinderV3(s) {
  const e = /* @__PURE__ */ new Set(), { languageTag: r, marketId: n } = s.locale;
  let a = {
    language: getLanguage(r),
    languageTag: r,
    marketId: n
  };
  return s.subscribe((o) => {
    a = o;
    for (const c of e)
      c(a);
  }), () => ({
    featureService: {
      getLocale: () => a,
      subscribe: (o) => (e.add(o), () => {
        e.delete(o);
      })
    }
  });
}
function defineLocaleService(s) {
  return {
    id: "locale-service",
    optionalDependencies: {
      featureServices: {
        "s2:logger": "^1.0.0"
      }
    },
    create: ({ featureServices: e }) => {
      const { "s2:logger": r = console } = e;
      return {
        "1.0.0": createBinderV1({ locale: s.locale, logger: r }),
        "2.2.0": createBinderV2({ ...s, logger: r }),
        "3.0.0": createBinderV3(s)
      };
    }
  };
}
function createRandomValue() {
  return String(crypto.getRandomValues(new Uint32Array(1))[0]);
}
function parseLoginState(s) {
  const e = api.get(s);
  if (e)
    try {
      const r = JSON.parse(e);
      if (typeof r == "object" && r !== null) {
        if (typeof r.uid == "string" && (r.customerType === "private" || r.customerType === "commercial"))
          return {
            status: "logged-in",
            uid: r.uid,
            customerType: r.customerType
          };
        if (r.status === "login-error")
          return { status: "login-error" };
      }
    } catch {
    }
  return { status: "logged-out" };
}
function defineLoginService(s) {
  const { authorizePathname: e, logoutPathname: r, authorizeStateCookieName: n, loginStateCookieName: a } = s;
  return {
    id: "login-service",
    dependencies: {
      featureServices: {
        "locale-service": "^3.0.0"
      }
    },
    optionalDependencies: {
      featureServices: {
        "pub-sub": "^1.0.0"
      }
    },
    create: ({ featureServices: o }) => {
      const c = o["locale-service"], d = o["pub-sub"], u = () => {
        d == null || d.publish("before-login");
        const { languageTag: Z } = c.getLocale(), { origin: y, pathname: w, search: A } = document.location, L = JSON.stringify([
          createRandomValue(),
          `${w}${A}`
        ]);
        api.set(n, L, { path: "/" });
        const F = new URL(e, y);
        F.searchParams.set("languageTag", Z), window.location.assign(F.href);
      }, l = (Z = window.location.href.replace(window.location.origin, "")) => {
        window.location.assign(`${r}?redirectPath=${encodeURIComponent(Z)}`);
      }, f = parseLoginState(a), h = f.status === "logged-in", v = f.status === "logged-in" ? { uid: f.uid, customerType: f.customerType } : void 0;
      return window.addEventListener("pageshow", (Z) => {
        Z.persisted && f.status !== parseLoginState(a).status && location.reload();
      }), {
        "1.0.0": () => ({
          featureService: { login: u, logout: l, isLoggedIn: h }
        }),
        "2.1.0": () => ({
          featureService: { login: u, logout: l, loginState: v }
        }),
        "3.0.0": () => ({
          featureService: { login: u, logout: l, loginState: f }
        })
      };
    }
  };
}
function definePageContextService(s) {
  const { initialPageContext: e, subscribe: r } = s;
  return {
    id: "page-context-service",
    create: () => {
      const n = /* @__PURE__ */ new Set();
      let a = e;
      return r((o) => {
        a = o;
        for (const c of n)
          c(a);
      }), {
        "1.0.0": () => ({
          featureService: {
            getPageContext: () => a,
            subscribe: (o) => (n.add(o), () => {
              n.delete(o);
            })
          }
        })
      };
    }
  };
}
const storageKey = "smart-payment-config-service-v1", storage = typeof window > "u" ? void 0 : window.sessionStorage;
function writeToStorage(s, e) {
  if (storage)
    try {
      storage.setItem(storageKey, JSON.stringify(s));
    } catch (r) {
      e.error(r);
    }
}
function readFromStorage(s) {
  if (!storage)
    return {};
  try {
    const e = storage.getItem(storageKey);
    return e ? JSON.parse(e) : {};
  } catch (e) {
    return s.error(e), {};
  }
}
var PaymentConfigMode;
(function(s) {
  s.CASHBUY = "cash-buy", s.LEASING = "leasing", s.FINANCE = "finance";
})(PaymentConfigMode = PaymentConfigMode || (PaymentConfigMode = {}));
const paymentConfigServiceDefinition = {
  id: "payment-config-service",
  optionalDependencies: {
    featureServices: {
      "s2:logger": "^1.0.0"
    }
  },
  create: ({ featureServices: s }) => {
    const { "s2:logger": e = console } = s, r = /* @__PURE__ */ new Set();
    let n, a, { config: o, leasingParams: c, params: d } = readFromStorage(e);
    const u = [];
    return {
      "1.0.0": (l) => ({
        featureService: {
          getConfig: () => o,
          setConfig: async (f) => {
            o = f, f.mode === PaymentConfigMode.FINANCE ? d = f.params : f.mode === PaymentConfigMode.LEASING && (c = f.leasingParams, d = f.params), writeToStorage({ config: o, leasingParams: c, params: d }, e);
            for (const [h] of r) {
              const v = h({
                consumerId: l,
                purchaseItem: { type: "none" }
              });
              v instanceof Promise && await v;
            }
          },
          subscribe: (f, h) => {
            const v = [
              f,
              (h == null ? void 0 : h.matchers) ?? ["submit"]
            ];
            return r.add(v), createUnsubscribe(() => r.delete(v), h);
          },
          registerCalculatorLoader: (f, h) => (n = f, Promise.resolve().then(() => {
            n === f && u.length > 0 && n();
          }), createUnsubscribe(() => {
            n === f && (n = void 0);
          }, h)),
          registerCalculator: (f, h) => (a = f, Promise.resolve().then(() => {
            do
              if (a === f) {
                const v = u.shift();
                v && a(...v);
              } else
                break;
            while (u.length > 0);
          }), createUnsubscribe(() => {
            a === f && (a = void 0);
          }, h)),
          openCalculator: ({ purchaseItem: f, initialConfig: h = o }) => {
            const v = async (y, w) => {
              o = y, o.mode === PaymentConfigMode.FINANCE ? d = o.params : o.mode === PaymentConfigMode.LEASING && (c = o.leasingParams, d = o.params);
              for (const [A, L] of r) {
                if (!L.includes(w))
                  continue;
                const F = A({
                  consumerId: l,
                  purchaseItem: f
                });
                F instanceof Promise && await F;
              }
              w === "submit" && writeToStorage({ config: o, leasingParams: c, params: d }, e);
            }, Z = [
              {
                purchaseItem: f,
                calculatorConfig: h && {
                  leasingParams: c,
                  params: d,
                  ...h
                }
              },
              (y) => v(y, "submit"),
              v
            ];
            a ? a(...Z) : (u.push(Z), n == null || n());
          }
        }
      })
    };
  }
};
function createUnsubscribe(s, e = {}) {
  var r;
  return (r = e.signal) == null || r.addEventListener("abort", s), s;
}
function definePricePreferencesProvider(s) {
  const { initialPriceType: e, initialShowPrices: r } = s;
  let n = e, a = r;
  const o = /* @__PURE__ */ new Set(), c = () => {
    for (const d of o)
      d();
  };
  return {
    id: "price-preferences-provider",
    create: () => ({
      "1.0.0": () => ({
        featureService: {
          getPriceType: () => n,
          setPriceType: (d) => {
            n !== d && (n = d, c());
          },
          getShowPrices: () => a,
          setShowPrices: (d) => {
            a !== d && (a = d, c());
          },
          subscribe: (d, u) => {
            o.add(d);
            const l = () => o.delete(d);
            return u == null || u.signal.addEventListener("abort", l), l;
          }
        }
      })
    })
  };
}
const pubSubServiceDefinition = {
  id: "pub-sub",
  create: () => {
    const s = /* @__PURE__ */ new Map();
    return {
      "1.0.0": () => ({
        featureService: {
          publish: (e) => {
            const r = s.get(e);
            if (r)
              for (const n of r)
                n();
          },
          subscribe: (e, r, n = {}) => {
            var a, o;
            const c = (a = s.get(e)) !== null && a !== void 0 ? a : /* @__PURE__ */ new Set();
            s.set(e, c), c.add(r);
            const d = () => c.delete(r);
            return (o = n.signal) === null || o === void 0 || o.addEventListener("abort", d), d;
          }
        }
      })
    };
  }
};
function defineSelectedVehicleService(s) {
  const { marketId: e, masterPn18: r } = s;
  return {
    id: "selected-vehicle-service",
    create: () => {
      const n = /* @__PURE__ */ new Set();
      let a;
      return {
        "1.0.0": () => ({
          featureService: {
            masterPn18: r ?? (e === "gb" ? "HX1ETD3B62EU010418" : "HX1ETD3A61EU010417"),
            getSelectedVehicle: () => a,
            setSelectedVehicle: (c) => {
              a = c;
              for (const d of n)
                d(a);
            },
            subscribe: (c) => (n.add(c), () => n.delete(c))
          }
        })
      };
    }
  };
}
var createRoot, m = require$$0;
if (process.env.NODE_ENV === "production")
  createRoot = m.createRoot, m.hydrateRoot;
else {
  var i = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  createRoot = function(s, e) {
    i.usingClientEntryPoint = !0;
    try {
      return m.createRoot(s, e);
    } finally {
      i.usingClientEntryPoint = !1;
    }
  };
}
function getClientConfig() {
  const s = document.querySelector("#clientConfig").textContent.trim();
  return JSON.parse(decodeURIComponent(s));
}
const createFeatureAppIntegrator = ({
  App: s,
  id: e,
  defaultPn18: r = "HX1ETD3A61EU010418",
  clientConfig: n,
  rootQuerySelector: a = "main"
}) => {
  const { locale: o, endpointDirectory: c } = n || getClientConfig(), d = defineHistoryService(
    createRootLocationTransformer({
      consumerPathsQueryParamName: "---",
      primaryConsumerHistoryKey: e
    })
  ), u = defineLogger(), l = defineLocaleService({
    locale: o,
    subscribe: () => {
    }
  }), f = definePageContextService({
    initialPageContext: {
      isCustomizerFeatureAppDefined: e.includes("customizer")
    },
    subscribe: () => {
    }
  }), h = defineEndpointDirectory(c), v = defineSelectedVehicleService({
    masterPn18: r
  }), Z = defineLoginService({
    authorizePathname: "/authorize",
    logoutPathname: "/logout",
    authorizeStateCookieName: "smart-authorize_state",
    loginStateCookieName: "smart-login_state"
  }), y = definePricePreferencesProvider({
    initialPriceType: "private",
    initialShowPrices: !0
  }), w = defineAdbContextService({
    cookieName: "smart-adb_context_state",
    resetPathname: "/adb-context-reset"
  }), { featureAppManager: A } = createFeatureHub(e, {
    moduleLoader: loadFederatedModule,
    featureServiceDefinitions: [
      d,
      l,
      h,
      v,
      Z,
      paymentConfigServiceDefinition,
      f,
      y,
      pubSubServiceDefinition,
      w,
      u
    ],
    featureServiceDependencies: {
      [paymentConfigServiceDefinition.id]: "^1.0.0"
    }
  });
  return createRoot(document.querySelector(a)).render(
    /* @__PURE__ */ jsx(React.StrictMode, { children: /* @__PURE__ */ jsx(FeatureHubContextProvider, { value: { featureAppManager: A }, children: /* @__PURE__ */ jsx(
      s,
      {
        locale: o,
        endpointDirectory: c,
        FeatureAppContainer
      }
    ) }) })
  );
}, SPLIT_LOWER_UPPER_RE = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), SPLIT_UPPER_UPPER_RE = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), SPLIT_SEPARATE_NUMBER_RE = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), DEFAULT_STRIP_REGEXP = /[^\p{L}\d]+/giu, SPLIT_REPLACE_VALUE = "$1\0$2", DEFAULT_PREFIX_SUFFIX_CHARACTERS = "";
function split(s) {
  let e = s.trim();
  e = e.replace(SPLIT_LOWER_UPPER_RE, SPLIT_REPLACE_VALUE).replace(SPLIT_UPPER_UPPER_RE, SPLIT_REPLACE_VALUE), e = e.replace(DEFAULT_STRIP_REGEXP, "\0");
  let r = 0, n = e.length;
  for (; e.charAt(r) === "\0"; )
    r++;
  if (r === n)
    return [];
  for (; e.charAt(n - 1) === "\0"; )
    n--;
  return e.slice(r, n).split(/\0/g);
}
function splitSeparateNumbers(s) {
  const e = split(s);
  for (let r = 0; r < e.length; r++) {
    const n = e[r], a = SPLIT_SEPARATE_NUMBER_RE.exec(n);
    if (a) {
      const o = a.index + (a[1] ?? a[2]).length;
      e.splice(r, 1, n.slice(0, o), n.slice(o));
    }
  }
  return e;
}
function pascalCase(s, e) {
  const [r, n, a] = splitPrefixSuffix(s, e), o = lowerFactory(e == null ? void 0 : e.locale), c = upperFactory(e == null ? void 0 : e.locale), d = pascalCaseTransformFactory(o, c);
  return r + n.map(d).join("") + a;
}
function lowerFactory(s) {
  return (e) => e.toLocaleLowerCase(s);
}
function upperFactory(s) {
  return (e) => e.toLocaleUpperCase(s);
}
function pascalCaseTransformFactory(s, e) {
  return (r, n) => {
    const a = r[0];
    return (n > 0 && a >= "0" && a <= "9" ? "_" + a : e(a)) + s(r.slice(1));
  };
}
function splitPrefixSuffix(s, e = {}) {
  const r = e.split ?? (e.separateNumbers ? splitSeparateNumbers : split), n = e.prefixCharacters ?? DEFAULT_PREFIX_SUFFIX_CHARACTERS, a = e.suffixCharacters ?? DEFAULT_PREFIX_SUFFIX_CHARACTERS;
  let o = 0, c = s.length;
  for (; o < s.length; ) {
    const d = s.charAt(o);
    if (!n.includes(d))
      break;
    o++;
  }
  for (; c > o; ) {
    const d = c - 1, u = s.charAt(d);
    if (!a.includes(u))
      break;
    c = d;
  }
  return [
    s.slice(0, o),
    r(s.slice(o, c)),
    s.slice(c)
  ];
}
const DEFAULT_SRC = "/assets/feature-app/feature-app.js", FeatureApp = ({
  config: s,
  done: e,
  envName: r,
  name: n,
  src: a = DEFAULT_SRC,
  id: o
}) => {
  var l, f;
  const c = useId(), d = React__default.useContext(FeatureAppEnvContext), u = ((f = (l = d == null ? void 0 : d.featureServices) == null ? void 0 : l["endpoint-directory"]) == null ? void 0 : f.envName) ?? r;
  return /* @__PURE__ */ jsx(
    FeatureAppLoader,
    {
      featureAppId: o ?? `${n}-${u}-${c}`,
      featureAppName: pascalCase(n),
      baseUrl: `/__app__/${n}/${u}`,
      src: a,
      config: s,
      done: e
    }
  );
};
export {
  FeatureApp,
  FeatureAppEnvContext,
  FeatureAppEnvProvider,
  createFeatureAppDefinition,
  createFeatureAppIntegrator,
  getClientConfig,
  useFeatureAppEnv,
  usePriceType,
  useSalesChannel,
  useSpaNavigation
};
//# sourceMappingURL=index.mjs.map
